import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, ProgressBar, Accordion, Table} from "react-bootstrap";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { getCurrentUser, getDataAtual, tiposSessoesCampos, formataDataHoraExibicao, formataDataExibicao, isUUID, tiposSessoesAtendExtra } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import { FaArrowDown, FaArrowUp, FaCheck, FaTimes, FaStream, FaEye, FaCheckCircle, FaEdit,FaChevronDown, FaChevronUp, FaExclamationTriangle, FaTeamspeak, FaSearch, FaEraser, FaQuestionCircle } from "react-icons/fa";
import SelecionarFaqModal from "../FAQ/SelecionarFaqModal";
import { PDFDocument, StandardFonts } from 'pdf-lib';
import FormularioRender from '../Formularios/FormularioRender';
import { getConfig } from "../../common/config";

// Piso da fonte nos campos de linha única do PDF de farmacovigilância: valores
// maiores que a caixa (nome do programa, e-mail longo) seriam cortados na borda.
const FARMACO_TEXT_MIN_FONT_SIZE = 5;


class AtendimentoGeralEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChangeCampo = this.handleChangeCampo.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);
        this.toggleDetalhesRelato = this.toggleDetalhesRelato.bind(this);

        this.state = {
            atendimento_id: '',
            uuid: '',
            data: '',
            atendente_id: '',
            receptivo_nome: '',
            receptivo_cpf: '',
            receptivo_para_quem: '',
            receptivo_para_quem_outro: '',
            receptivo_email: '',
            receptivo_telefone: '',
            receptivo_texto: '',
            filtro_cliente_id: '',
            filtro_cliente_nome: '',
            filtro_programa_id: '',
            filtro_programa_nome: '',
            relato_id: '',
            farmacovigilancia_formulario_id: '',
            farmacovigilancia_relato: '',
            camposFormulario: [],
            valoresFormulario: {},
            camposOutro: {},
            renderiza_campos: false,
            nomeHelper: '',
            paraHelper: '',
            emailHelper: '',
            telefoneHelper: '',
            textoHelper: '',
            erroLoadRegistro: "",
            titulo_pagina: "",
            loading: false,
            liberaBtnWhatsApp: false,
            twilio_retorno: '',
            botoes_atendimento: [],
            botao_atual: {},
            showModalBotao: false,
            relatos_atendimento: [],
            exibirDetalhesRelato: {},
            programa_status_id: '',
            programa_dados: [],
            atendimento_campos: [],
            programa_id: '',
            programa_status_slug: '',
            dados_atendente: {},
            opcoes_atendimentos_para: {},
            acoes: [],
            showModalAcoes: false,
            programa_acao_id: '',
            programa_acao_nome: '',
            acao_id: '',
            acao_descricao: '',
            acao_observacoes: '',
            acao_realizado: '',
            acao_data: '',
            acao_hora: '',
            valoresCamposExtra: {},
            produtosOpcoes: [],
            showFaqModal: false,
            modalBusca: '',
            faqs_selecionadas: [], // [{ id, pergunta, resposta }]
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;
        const dados_user = getCurrentUser();        

        if(id) {
            const isInteger = /^\d+$/.test(id);

            if (isInteger || !isUUID(id)) {
                window.location.href = '/sem-permissao';
                return;
            }

            this.setState({
                uuid: id,
                titulo_pagina: 'Editando Atendimento Receptivo',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/atendimentos/${id}/`)
            .then(response => {
                const dados = response.data;
                const programaId = dados.programa_id

                //Verifica, se tem ambiente de programa e a ID é de outro
                if(dados_user['ambiente_programa_id'] && dados_user['ambiente_programa_id'] != dados.programa_id) {
                    window.location.href = '/sem-permissao';
                    return;
                }

                //Verifica campos extras
                const valoresInicial = {};

                dados.extra_valores_list.forEach(campo => {
                    if (campo.repetidor_list && campo.repetidor_list.length) {
                        const definicoes = campo.repetidor_list.filter((v,i,arr) =>
                            arr.findIndex(x => x.subcampo_id === v.subcampo_id) === i
                        );
                        const subCount = definicoes.length;

                        const rows = [];
                        for (let i = 0; i < campo.repetidor_list.length; i += subCount) {
                            const chunk = campo.repetidor_list.slice(i, i + subCount);
                            const obj = {};
                            chunk.forEach(r => {
                                obj[r.subcampo_id] = {
                                    id:    r.id,
                                    valor: r.valor
                                };
                            });
                            rows.push(obj);
                        }

                        valoresInicial[campo.campo_id] = rows;
                    }
                });

                //preenche os inputs
                this.setState({
                    uuid: dados.uuid,
                    atendimento_id: dados.id,
                    erroLoadRegistro: '',
                    atendente_id: dados.atendente_id,
                    data: dados.data,
                    receptivo_nome: dados.receptivo_nome,
                    receptivo_cpf: dados.receptivo_cpf,
                    receptivo_para_quem: dados.receptivo_para_quem,
                    receptivo_para_quem_outro: dados.receptivo_para_quem_outro,
                    receptivo_email: dados.receptivo_email,
                    receptivo_telefone: dados.receptivo_telefone,
                    receptivo_texto: dados.receptivo_texto,
                    filtro_cliente_id: dados.cliente_id,
                    filtro_cliente_nome: dados.dados_cliente.nome,
                    filtro_programa_id: dados.programa_id,
                    filtro_programa_nome: dados.dados_programa.nome,
                    programa_id: programaId,
                    cliente_id: dados.cliente_id,
                    twilio_retorno: dados.twilio_retorno,
                    programa_status_id: dados.programa_status_id,
                    camposExtraCadastrados: dados.extra_valores_list,
                    programa_status_slug: dados.dados_programa_status?.slug,
                    valoresCamposExtra: valoresInicial,
                    proxima_acao: dados.proxima_acao,
                    proxima_acao: dados.proxima_acao,
                    dados_atendente: dados.dados_atendente,
                    faqs_selecionadas: dados.dados_programa_faqs || [], // Assuming backend returns list


                }, () => {
                    this.fetchProdutosPrograma();
                    this.carregarRelatosAtendimento();
                    this.carregaCamposExtraPrograma();
                    this.carregarAcoes();
                });

                if (programaId) {
                    this.carregaDadosPrograma(programaId);
                    this.carregaBotoesAtendimento(programaId);
                }
                
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar atendimento, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                atendimento_id: '',
                titulo_pagina: 'Adicionar Atendimento Receptivo',
                loading: false,
                erroLoadRegistro: '',
                valoresCamposExtra: {},
            })

            if(dados_user.ambiente_programa_id) {
                this.carregaDadosPrograma(dados_user.ambiente_programa_id);
            }
        }
    }

    carregaDadosPrograma = (programaId) => {
        const programa_id = programaId
        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    const dadosResponse = response.data;
                    this.setState({ 
                        programa_dados: dadosResponse, 
                        opcoes_atendimentos_para: dadosResponse.opcoes_atendimentos_para, 
                        loading: false 
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                    //Sentry.captureException('Erro ao carregar dados do programa atual:', error);
                    
                    let erro_msg = 'Erro ao carregar dados do programa, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    };

    carregarRelatosAtendimento = () => {
        if (this.state.atendimento_id) {
            api.get(`/atendimentos/relatos/?atendimento_id=${this.state.atendimento_id}`)
                .then(response => {
                    // Filtra apenas os relatos do tipo "atendimento"
                    const relatosAtendimento = response.data.results.filter(relato => relato.tipo === "atendimento");
    
                    this.setState({ relatos_atendimento: relatosAtendimento });
                })
                .catch(error => {
                    console.error('Erro ao carregar relatos do atendimento:', error);
                    Sentry.captureException('Erro ao carregar relatos do atendimento:', error);
    
                    let erro_msg = 'Erro ao carregar relatos do atendimento, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                    });
                });
        }
    };

    carregaBotoesAtendimento = (programa_id) => {
        if(programa_id) {
            api.get(`/programas/botoes/?programa_id=${programa_id}`)
                .then(response => {
                    this.setState({ botoes_atendimento: response.data.results });
                })
                .catch(error => {
                    console.error('Erro ao carregar os botões de atendimento:', error);
                    //Sentry.captureException('Erro ao carregar os botões de atendimento:', error);
                    
                    let erro_msg = 'Erro ao carregar os botões de atendimento, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente (botões de atendimento)';
                    }

                    this.setState({
                        erroLoadRegistro: erro_msg,
                    })
                });
        }
    }

    renderModalBotao = () => {
        const {
            camposFormulario,
            valoresFormulario,
            camposOutro,
            opcaoModalRelato
        } = this.state;
        
        const dados_usuario = getCurrentUser();
        
        return (
            <Modal show={this.state.showModalBotao} size="lg" onHide={this.handleCloseModalBotao}>
                <Modal.Header closeButton>
                    <Modal.Title>{this.state.botao_atual.titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{this.state.botao_atual.descricao}</p>
                    {this.state.camposFormulario.length > 0 && (
                    <Form onSubmit={this.handleSubmitModalAtendimento}>
                        <FormularioRender
                            campos={camposFormulario}
                            camposOutro={camposOutro}
                            valoresCampos={valoresFormulario}
                            onChangeCampo={this.handleChangeCampo}
                            onChangeCampoAsync={this.handleChangeCampoAsync}
                            onChangeCampoCheckSim={this.handleChangeCampoCheckSim}
                            onChangeOutro={this.handleChangeOutro}
                            dadosUsuario={dados_usuario}
                            opcaoModalRelato={opcaoModalRelato}
                            tiposSessoesCampos={tiposSessoesCampos}
                            carregarProdutosPrograma={this.carregarProdutosPrograma}
                            produtosOpcoes={this.state.produtosOpcoes}
                        />
                        <Row>
                            <Col sm={12}>
                                <Button variant="success" size="sm" type="submit" disabled={this.state.loading}>{this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Salvar Informações'}</Button>
                            </Col>
                        </Row>
                    </Form>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalBotao}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    handleShowModalBotao = (botao) => {
        //executa uma funcao caso esteja cadastrado
        if(botao.callback_funcao){
            executeFunctionByName(botao.callback_funcao, this);
        }

        this.setState({
            botao_atual: botao,
            showModalBotao: true,
            camposFormulario: [],
        });

        // Aqui fazemos a chamada para a API para buscar os campos do formulário
        api.get(`/formularios/campos/?formulario_id=${botao.formulario_id}&status=1&limit=500`)
            .then(response => {
                // Atualizamos o estado com os campos recebidos
                this.setState({ camposFormulario: response.data.results, loading: false });
            })
            .catch(error => {
                console.error('Erro ao carregar campos do formulário:', error);

                this.setState({ loading: false });
                // Aqui você pode adicionar alguma notificação ao usuário sobre o erro
                //Sentry.captureException('Erro ao carregar campos do formulário:', error);
            });
    };
    
    handleCloseModalBotao = () => {
        this.setState({
            botao_atual: {},
            showModalBotao: false,
            camposFormulario: [],
            valoresCampos: {},
            valoresFormulario: {}
        });
    };

    enviaRegistro = (e, opcao) => {
        e.preventDefault();

        let dados_usuario = getCurrentUser();
        const MySwal = withReactContent(Swal);

        /*if(!this.state.receptivo_cpf) {
            MySwal.fire({
                icon: 'warning',
                title: <p>Atenção</p>,
                text: 'Por favor, o preenchimento do CPF é obrigatório',
                showCloseButton: true,
            });
            return;
        }*/

        const formData = new FormData();

        this.setState({
            loading: true,
            nomeHelper: "",
            paraHelper: "",
            telefoneHelper: "",
            emailHelper: "",
            textoHelper: "",
        });

        //vererifica se é edição ou adição
        const url = (this.state.atendimento_id) ? '/atendimentos/'+this.state.atendimento_id+'/' : '/atendimentos/'
        const metodo = (this.state.atendimento_id) ? 'put' : 'post'

        const programa_id = dados_usuario['ambiente_programa_id'] || this.state.filtro_programa_id;
        const cliente_id = dados_usuario['ambiente_cliente_id'] || this.state.filtro_cliente_id;

        if(this.state.receptivo_nome) {
            formData.append('receptivo_nome', this.state.receptivo_nome);
        }
        if(this.state.receptivo_cpf) {
            formData.append('receptivo_cpf', this.state.receptivo_cpf);
        }
        if(this.state.receptivo_para_quem) {
            formData.append('receptivo_para_quem', this.state.receptivo_para_quem);
        }

        if(this.state.receptivo_para_quem === 'outros' && this.state.receptivo_para_quem_outro) {
            formData.append('receptivo_para_quem_outro', this.state.receptivo_para_quem_outro);
        }
        if(this.state.receptivo_email) {
            formData.append('receptivo_email', this.state.receptivo_email);
        }
        if(this.state.receptivo_telefone) {
            formData.append('receptivo_telefone', this.state.receptivo_telefone);
        }
        if(this.state.receptivo_texto) {
            formData.append('receptivo_texto', this.state.receptivo_texto);
        }

        if(this.state.programa_status_id) {
            formData.append('programa_status_id', this.state.programa_status_id);
        }

        formData.append('cliente_id', cliente_id);
        formData.append('programa_id', programa_id);
        formData.append('tipo_atendimento', 'receptivo');
        
        if(dados_usuario['operador_id'] > 0 && !this.state.atendimento_id) {
            formData.append('atendente_id', dados_usuario['operador_id']);
        }

        if(!this.state.atendimento_id) {
            const data_atual = getDataAtual();
        
            formData.append('data', data_atual);
        }

        if(opcao == 'com_whatsapp'){
            formData.append('enviar_whatsapp', 1)
        }

        if (this.state.faqs_selecionadas.length > 0) {
            this.state.faqs_selecionadas.forEach(f => {
                formData.append('programa_faq_ids', f.id);
            });
        }

        //campos extras do atendimento
        let cont = 1;
        let list_valores = [];

        Object.entries(this.state.valoresCamposExtra).forEach(([campoId, valor]) => {
            const campo = this.state.atendimento_campos.find(c => c.id === parseInt(campoId));

            let dados = {
                valor: "",
                file_param: "",
                campo_id: campoId,
                repeater: []
            };

            if (campo.tipo === 'repeater') {
                if (Array.isArray(valor)) {
                    valor.forEach((repetidorItem, idx) => {
                        let bloco = {};
                        Object.entries(repetidorItem).forEach(([id, val]) => {
                            bloco = {
                                'subcampo_id': id,
                                'valor': val,
                            };
                            dados.repeater.push(bloco);
                        });
                        
                    });
                }
            }

            else if (valor instanceof File) {
                let file_param = `valor_arquivo_${cont}`;
                dados.file_param = file_param;
                formData.append(file_param, valor);
            }

            else if (typeof valor === "boolean") {
                dados.valor = valor;
            }

            else if (typeof valor === "string" && valor.toLowerCase() === 'outro' && this.state.camposOutrosExtra[campoId]) {
                dados.valor = `Outro - ${this.state.camposOutrosExtra[campoId]}`;
            }

            else {
                dados.valor = valor;
            }

            list_valores.push(dados);
            cont++;
        });

        if (list_valores.length > 0) {
            formData.append('valores', JSON.stringify(list_valores));
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const id_atendimento = (this.state.atendimento_id) ? this.state.atendimento_id : response.data.id;

            const uidid_atendimento = (this.state.uuid) ? this.state.uuid : response.data.uuid;
            
            if(this.state.farmacovigilancia_relato == "sim"){
                this.enviarFormularioFarmacovigilancia(id_atendimento);
            } else {
                const MySwal = withReactContent(Swal)
                const textSwal = (this.state.doenca_id) ? 'Atendimento atualziado com sucesso' : 'Atendimento cadastrado com sucesso';

               

                MySwal.fire({
                    title: 'Sucesso!',
                    html: <p>{textSwal}</p>,
                    icon: 'success',
                    showCloseButton: true,
                })
                
                this.setState({
                    loading: false,
                })
                
                //redireciona
                window.location.href = `/atendimentos-receptivo/edit/${uidid_atendimento}`;
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao registrar o atendimento, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'receptivo_para_quem'){
                        this.setState({ paraHelper: value })
                    }
                    if(key === 'receptivo_nome'){
                        this.setState({ nomeHelper: value })
                    }
                    if(key === 'receptivo_cpf'){
                        this.setState({ cpfHelper: value })
                    }
                    if(key === 'receptivo_email'){
                        this.setState({ emailHelper: value })
                    }
                    if(key === 'receptivo_telefone'){
                        this.setState({ telefoneHelper: value })
                    }
                    if(key === 'receptivo_texto'){
                        this.setState({ textoHelper: value })
                    }
                    if(key === 'filtro_cliente_id'){
                        this.setState({ clienteHelper: value })
                    }
                    if(key === 'filtro_programa_id'){
                        this.setState({ programaHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção!',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if(name == 'receptivo_telefone'){
            if(value.length == 15 && this.state.programa_dados.template_atendimento_receptivo){
                this.setState({ liberaBtnWhatsApp: true });
            }
            else {
                this.setState({ liberaBtnWhatsApp: false });
            }
        }
    };

    handleRelatoChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value }, () => {
            if (name === "farmacovigilancia_relato" && value === "sim") {
                let dados_usuario = getCurrentUser();

                const programa_id = (dados_usuario['ambiente_programa_id']) ? dados_usuario['ambiente_programa_id'] : this.state.programa_id;
                this.carregarFarmacovigilanciaFormulario(programa_id);
            }
        });
    };


    carregarClientes = async (inputValue) => {
        try {
            const response = await api.get(`/pessoas/clientes/?nome=${inputValue}`);
            const opcoes = response.data.results.map(cliente => ({
                value: cliente.id,
                label: `${cliente.dados_pessoa.nome_fantasia} (${cliente.dados_pessoa.razao_social})`
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar clientes:', error);
            return [];
        }
    };

    carregarProdutosPrograma = async (inputValue) => {
        if (this.state.showModalBotao) {
            const dados_usuario = getCurrentUser();
            const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;
            try {
                const response = await api.get(`/programas/produtos/?produto=${inputValue}&programa=${programa_id}&status=1`);
                
                // Extrair nomes únicos
                const nomesUnicos = Array.from(
                    new Set(
                        response.data.results.map(produto => produto.dados_produto.nome.split(' - ')[0]) // Pega apenas o nome antes do " - "
                    )
                );
    
                // Mapear para o formato esperado
                const opcoes = nomesUnicos.map(nome => ({
                    value: nome,
                    label: nome
                }));
    
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar produtos:', error);
                return [];
            }
        }
    };

    carregaProgramas = async (inputValue) => {
        if(!this.state.filtro_cliente_id) {
            return [];
        }

        try {
            const response = await api.get(`/programas/?nome=${inputValue}&cliente_id=${this.state.filtro_cliente_id}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    async carregarFarmacovigilanciaFormulario(programa_id) {
        try {
            const response = await api.get(`/programas/${programa_id}/`);
            const programa = response.data;
            const farmacovigilanciaFormularioId = programa.farmacovigilancia_formulario_id;
            
            if(farmacovigilanciaFormularioId && this.state.farmacovigilancia_relato == "sim"){
                const camposFormulario = await api.get(`/formularios/campos/?formulario_id=${farmacovigilanciaFormularioId}&status=1`);
                try {
                    this.setState({
                        farmacovigilancia_formulario_id: farmacovigilanciaFormularioId
                    });
                } catch (error) {
                    
                }

                const valoresFormulario = await api.get(`/atendimentos/relatos/?atendimento_id=${this.state.atendimento_id}&status=1`);

                try {
                    valoresFormulario.data.results[0].valores_list.forEach(campo => {
                        // Atualiza o estado com o campo correspondente
                        this.setState(prevState => ({
                            relato_id: valoresFormulario.data.results[0].id,
                            camposFormulario: camposFormulario.data.results,
                            valoresFormulario: {
                                ...prevState.valoresFormulario,  // Espalha o conteúdo atual
                                [campo.formulario_campo_id]: campo.valor,  // Adiciona ou atualiza o valor
                            },
                        }), () => {
                            // Callback após o estado ser atualizado
                            this.setState({
                                renderiza_campos: true
                            });
                        });
                    });
                    
                } catch (error) {
                    
                }
            }
            
        } catch (error) {
            console.error('Erro ao buscar o formulario de farmacovigilancia do programa:', error);
        }
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'cliente_id') {
            this.setState(prevState => ({
                filtro_cliente_id: event.value, 
                filtro_cliente_nome: event.label,
                filtro_programa_id: "", 
                filtro_programa_nome: "",
                programa_select_key: prevState.programa_select_key + 1 
            }));
        }
        else if(fieldName == 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label, 
            }));

            this.carregarFarmacovigilanciaFormulario(event.value);
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangeCampo = (id, value) => {
        // Verifica se o valor é um evento (para campos de arquivo, por exemplo)
        const isEvent = value && value.target;

        let finalValue = value;

        // Se for um evento e um campo de arquivo, captura o arquivo; caso contrário, usa o valor diretamente
        if (isEvent && value.target.type === "file") {
            finalValue = value.target.files[0]; // Pode ser undefined se nenhum arquivo for selecionado
        }
        else if(isEvent && (value.target.type === "checkbox" || value.target.type === "radio")){
            finalValue = value.target.checked
        } 
        else if (isEvent) {
            finalValue = value.target.value;
        }
        
        this.setState(prevState => {
            const novosCamposOutro = { ...prevState.camposOutro };

            // só checa "Outro" para campos de texto/select (não file/checkbox/radio)
            const shouldCheckOutro = !isEvent || (
                isEvent &&
                value.target.type !== "file" &&
                value.target.type !== "checkbox" &&
                value.target.type !== "radio"
            );
    
            if (shouldCheckOutro) {
                // normaliza finalValue para uma lista de tokens (suporta múltiplo como "a, b, Outro")
                let tokens = [];
                if (Array.isArray(finalValue)) {
                    tokens = finalValue;
                } else if (typeof finalValue === "string") {
                    tokens = finalValue.split(",");
                } else if (finalValue == null) {
                    tokens = [];
                } else {
                    tokens = [String(finalValue)];
                }

                const selecionouOutro = tokens
                    .map(t => (t ?? "").toString().trim().toLowerCase())
                    .includes("outro");

                if (selecionouOutro) {
                    if (!(id in novosCamposOutro)) novosCamposOutro[id] = "";
                } else {
                    delete novosCamposOutro[id];
                }
            }

            return {
                valoresFormulario: {
                    ...prevState.valoresFormulario,
                    [id]: finalValue,
                },
                camposOutro: novosCamposOutro,
            };
        });
    };

    handleChangeOutro = (id, valor) => {
        this.setState(prevState => ({
            camposOutro: {
                ...prevState.camposOutro,
                [id]: valor,
            },
        }));
    };

    // componentDidUpdate(prevProps, prevState) {
    //     if (prevState.valoresFormulario !== this.state.valoresFormulario) {
    //         console.log('Estado de valoresFormulario foi atualizado:', this.state.valoresFormulario);
    //     }

    //     if (prevState.camposFormulario !== this.state.camposFormulario) {
    //         console.log('Estado de camposFormulario foi atualizado:', this.state.camposFormulario);
    //     }
    // }

    enviarFormularioFarmacovigilancia = async (atendimento_id) => {

        // Primeiro, salvar o relato
        this.setState({loading:true})

        const dataHoraAtualFormatada = getDataAtual();
        const { camposFormulario, valoresFormulario, relato_id } = this.state;
        /*BUSCA ETAPAS DO PROGRAMA */
        const response = await api.get(`/programas/etapas/?programa_id=${this.state.filtro_programa_id}&status=1`);
        const etapa_id = response.data.results[0].id;

        let count = 1;
        let formData = new FormData();
        formData.append('data', dataHoraAtualFormatada);
        formData.append('etapa_id', etapa_id);
        formData.append('atendimento_id', atendimento_id);
        formData.append('tipo', 'atendimento');
        formData.append('titulo', "Relato de Farmacovigilância");
        formData.append('farmacovigilancia', true);
        Object.entries(valoresFormulario).forEach(([campoId, valor]) => {
            if (valor instanceof File) {
                formData.append(`valor_arquivo_${count}`, valor);
            } 
            else if (valor instanceof Boolean) {
                formData.append(`valor_valor_${count}`, valor ? true : false);
            }
            else {
                formData.append(`valor_valor_${count}`, valor);
            }
            formData.append(`valor_formulario_campo_id_${count}`, campoId);
            count++;
        });

        if(relato_id){
            console.log(relato_id);
            await api.delete(`/atendimentos/relatos/${relato_id}`);      
        }
        
        await api.post('/atendimentos/relatos/', formData)
        .then(response => {
            this.setState({loading:false})
            Swal.fire({
                title: 'Sucesso!',
                text: 'Atendimento salvo com sucesso.',
                icon: 'success'
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    window.location.href = `/atendimentos-receptivo/edit/${atendimento_id}`;
                }
            });
        })
        .catch(error => {
            this.setState({loading:false})
            console.error('Erro ao salvar o relato de atendimento:', error);
            Sentry.captureException('Erro ao salvar o relato de atendimento:', error);

            Swal.fire('Erro!', 'Não foi possível salvar o atendimento.', 'error');
        });

    };

    //Envio do formulário de botão de atendimento (Etapa Flutuante)
    handleSubmitModalAtendimento = (e) => {
        e.preventDefault(); // Isso evita a recarga da página
        this.enviarFormularioBotaoAtendimento();
    };

    enviarFormularioBotaoAtendimento = async () => {
        // Primeiro, salvar o relato
        this.setState({loading:true})

        const dataHoraAtualFormatada = getDataAtual();
        const { atendimento_id, valoresFormulario, camposOutro, programa_dados } = this.state;

        /*BUSCA ETAPAS DO PROGRAMA */
        const response = await api.get(`/programas/etapas/?programa_id=${this.state.filtro_programa_id}&status=1`);
        const etapa_id = response.data.results[0].id;

        let formData = new FormData();
        formData.append('data', dataHoraAtualFormatada);
        formData.append('etapa_id', etapa_id);
        formData.append('atendimento_id', atendimento_id);
        formData.append('tipo', 'atendimento');
        formData.append('titulo', this.state.botao_atual.titulo);
        formData.append('formulario_id', this.state.botao_atual.formulario_id);

        if(this.state.relato_tipo_paciente){
            formData.append('tipo_paciente', this.state.relato_tipo_paciente);      
        }
          
        //verifica se o botão atual é de um formulário de farmacovigilância
        if(this.state.botao_atual && this.state.botao_atual.dados_formulario.farmacovigilancia) {
            formData.append('farmacovigilancia', true);
        }

        let list_valores = []
        let cont = 1;
        Object.entries(valoresFormulario).forEach(([campoId, valorBruto]) => {            
            let valor = valorBruto; 

            const dados = {
                valor: "",
                file_param: "",
                formulario_campo_id: campoId,
                repeater: []
            };

            // 1) Se veio um event (ex.: input file passado direto)
            const isEvent = valor && typeof valor === 'object' && 'target' in valor;
            if (isEvent) {
                const { target } = valor;
                if (target.type === 'file' && target.files && target.files.length > 0) {
                valor = target.files[0];
                } else {
                valor = target.value; // fallback pra outros inputs
                }
            }

            // 2) Arquivo
            if (valor instanceof File) {
                const file_param = `valor_arquivo_${cont}`;
                dados.file_param = file_param;
                formData.append(file_param, valor);
            }
            // 3) Array (ex.: múltipla seleção)
            else if (Array.isArray(valor)) {
                dados.valor = valor.map(v => (v ?? '').toString().trim()).filter(Boolean).join(', ');
            }
            // 4) Boolean (primitivo)
            else if (typeof valor === 'boolean') {
                dados.valor = valor; 
            }
            // 5) null/undefined
            else if (valor === null || valor === undefined) {
                dados.valor = '';
            }
            // 6) Número
            else if (typeof valor === 'number') {
                dados.valor = String(valor);
            }
            // 7) String
            else if (typeof valor === 'string') {
                let vStr = valor;

                // “Outro” + texto complementar
                if (vStr.trim().toLowerCase() === 'outro' && camposOutro && camposOutro[campoId]) {
                vStr = `Outro - ${camposOutro[campoId]}`;
                }

                dados.valor = vStr;
            }
            // 8) Objeto genérico (ex.: JSON de campo_pdf ou algo estruturado)
            else if (typeof valor === 'object') {
                dados.valor = JSON.stringify(valor);
            }

            list_valores.push(dados);
            cont++;
        });

        if(list_valores.length > 0){
            formData.append('valores', JSON.stringify(list_valores))
        }
        
        //gera o pdf de farmaco com base em um modelo
        if (programa_dados.farmacovigilancia_pdf_modelo) {
            const nome_modelo = programa_dados.farmacovigilancia_modelo;

            let templateUrl = `/farmaco/${nome_modelo}_farmacovigilancia.pdf`;

            try {
                const pdfBlob = await this.gerarPdfFarmaco(templateUrl, valoresFormulario, camposOutro);

                // Alguns browsers não têm File(), então usamos Blob e passamos filename no terceiro arg de append
                formData.append('farmacovigilancia_pdf', pdfBlob, "farmacovigilancia.pdf");
            } 
            catch (e) {
                Swal.fire('Erro!', 'Falha ao gerar PDF de farmacovigilância.', 'error');
                console.error('Falha ao gerar PDF de farmacovigilância', e);
                return
            }
        }

        //gera o pdf de farmaco com base em um modelo
        if (programa_dados.farmacovigilancia_pdf_modelo) {
            const nome_modelo = programa_dados.farmacovigilancia_modelo;

            let templateUrl = `/farmaco/${nome_modelo}_farmacovigilancia.pdf`;

            try {
                const pdfBlob = await this.gerarPdfFarmaco(templateUrl, valoresCampos, camposOutro);

                // Alguns browsers não têm File(), então usamos Blob e passamos filename no terceiro arg de append
                formData.append('farmacovigilancia_pdf', pdfBlob, "farmacovigilancia.pdf");
            } 
            catch (e) {
                Swal.fire('Erro!', 'Falha ao gerar PDF de farmacovigilância.', 'error');
                console.error('Falha ao gerar PDF de farmacovigilância', e);
                return
            }
        }

        api.post('/atendimentos/relatos/', formData)
        .then(response => {
            const relatoId = response.data.id;
            
            this.setState({loading:false})
            Swal.fire({
                title: 'Sucesso!',
                text: 'Atendimento salvo com sucesso.',
                icon: 'success'
            }).then((result) => {
                if (result.isConfirmed || result.dismiss) {
                    this.handleCloseModalBotao(); // Chamada para fechar o modal
                    window.location.reload();
                }
            });
        })
        .catch(error => {
            this.setState({loading:false})
            console.error('Erro ao salvar o relato de atendimento:', error);

            Swal.fire('Erro!', 'Não foi possível salvar o atendimento.', 'error');
            //Sentry.captureException('Erro ao salvar o relato de atendimento:', error);
        });
    };

    renderizaCamposFormulario = () => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {}
        for(let i = 0; i < this.state.camposFormulario.length; i++) {
            let item = this.state.camposFormulario[i];
            const sessao = item.sessao || '0_sem_sessao'

            if(!(sessao in objCampos)){
                objCampos[sessao] = [];    
            }

            objCampos[sessao].push(item)
        }

        return (
            Object.keys(objCampos).map((nome_sessao) => (
                <div className="row-list" key={nome_sessao}>
                    {nome_sessao && <h6><strong>{tiposSessoesCampos[nome_sessao] ? tiposSessoesCampos[nome_sessao] : (nome_sessao === '0_sem_sessao' ? '' : nome_sessao)}</strong></h6>}            
                    
                    <Row>
                        {objCampos[nome_sessao].map((campo) => (
                        <React.Fragment key={campo.id}>
                            {campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' || campo.tipo === 'radio' ? (
                                <>
                                    <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>{campo.nome}</Form.Label>
                                            {
                                            (campo.mascara === 'produtos_programa') ? (
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarProdutosPrograma}
                                                    required={campo.obrigatorio}
                                                    defaultOptions
                                                    placeholder="Buscar produto..."
                                                    noOptionsMessage={() => "Nenhum produto encontrado"}
                                                    onChange={(option) => this.handleChangeCampo(campo.id, option)}
                                                    value={this.state.valoresFormulario[campo.id] ? { value: this.state.valoresFormulario[campo.id], label: this.state.valoresFormulario[campo.id] } : null}
                                                />
                                            )
                                            :
                                            (campo.tipo === 'selecao') ? (
                                                <Form.Control as="select" value={this.state.valoresFormulario[campo.id] || ''} required={campo.obrigatorio} onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}>
                                                    <option value="">Selecione...</option>
                                                    {campo.opcoes.split('\n').map((opcao, idx) => {
                                                        const [valor, label] = opcao.split(':');
                                                        return <option key={idx} value={valor}>{label}</option>;
                                                    })}
                                                </Form.Control>
                                                ) 
                                            : 
                                                (campo.tipo === 'texto' || campo.tipo === 'data') ? (
                                                    <Form.Control
                                                        type={campo.tipo === 'data' ? 'date' : 'text'}
                                                        value={this.state.valoresFormulario[campo.id] || ''}
                                                        required={campo.obrigatorio}
                                                        onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                    />
                                                )
                                                :
                                                    (campo.tipo === 'radio') ? 
                                                    (
                                                        <div>
                                                            {campo.opcoes.split('\n').map((opcao, indexO) => {
                                                                const [valorRadio, labelRadio] = opcao.split(':'); // Divide a opção pelo ':'
                                                                const radioSelecionado = valorRadio === this.state.valoresFormulario[campo.id];
                                                                
                                                                return (
                                                                    <Form.Check 
                                                                        inline 
                                                                        type="radio" 
                                                                        name={`radio_${campo.id}`}
                                                                        label={labelRadio} 
                                                                        key={`radio_${campo.id}_opcao_${indexO}`} 
                                                                        id={`radio_${campo.id}_opcao_${indexO}`}
                                                                        value={valorRadio} 
                                                                        onClick={() => {
                                                                            if (radioSelecionado) {
                                                                                this.handleChangeCampo(campo.id, '');
                                                                            }
                                                                        }}
                                                                        onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                                        checked={radioSelecionado} 
                                                                    />                                                                                                                        
                                                                );
                                                            })}
                                                        </div>
                                                    )
                                                    :
                                                    (
                                                        <Form.Control
                                                            as={campo.tipo === 'area_texto' ? 'textarea' : 'text'}
                                                            value={this.state.valoresFormulario[campo.id] || ''}
                                                            required={campo.obrigatorio}
                                                            className={campo.tipo === 'area_texto' ? 'custom-textarea2' : ''}
                                                            onChange={(e) => this.handleChangeCampo(campo.id, e.target.value)}
                                                        />
                                                    )
                                            }
                                            {campo.descricao && <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text>}
                                        </Form.Group>
                                    </Col>
                                    {this.state.valoresFormulario[campo.id]?.toLowerCase() === 'outro' && (
                                    <Col sm={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Descreva</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.camposOutro[campo.id] || ''}
                                                onChange={(e) => this.handleChangeOutro(campo.id, e.target.value)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    )}
                                </>
                            ) : null}
                            {campo.tipo === 'informacao' && (
                                <Col sm={12} className="mb-0">
                                    <div dangerouslySetInnerHTML={{ __html: campo.descricao }} />
                                </Col>
                            )}
                            {campo.tipo === 'gotoconnect' && (
                                <Col sm={12} className="mb-3">
                                    {
                                    this.state.goToClient_id
                                    ?
                                        this.state.loading
                                        ?
                                            <h4 className="text-center mt-3"><FaClock /> Carregando...</h4>
                                        :
                                            this.state.goToErroMensagem
                                            ?
                                                <h4 className="text-center mt-3"><FaExclamationTriangle /> {this.state.goToErroMensagem}</h4>
                                            :
                                                this.state.goToAccessToken 
                                                ?
                                                    this.state.goToLinhasAtendente.length > 0
                                                    &&
                                                    <div>
                                                        <Row>
                                                            <Col sm={6} xs={12} className="mb-3">
                                                                <Form.Group>
                                                                    <Form.Label>Linhas disponíveis</Form.Label>
                                                                    <Form.Control name="goToLinhaLigar" as="select" onChange={this.handleChange} value={this.state.goToLinhaLigar}>
                                                                        {this.state.goToLinhasAtendente.map((linha, idx) => {
                                                                            return <option key={idx} value={linha.id}>{linha.name} (Número: {linha.number})</option>;
                                                                        })}
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col sm={6} xs={12} className="mb-3">
                                                                <Button variant="success" size="sm" type="button" className="mt-4" disabled={this.state.goToLoaderLigacao} onClick={() => this.ligarParaPaciente(campo.id)}>
                                                                    {this.state.goToLoaderLigacao ? <span className="spinner-border spinner-border-sm"></span> : <><FaPhone className="me-2" /> Ligar para {this.state.beneficiario_celular}</>}
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                        {
                                                        this.state.goToLigacaoRealizada &&
                                                        <Alert variant="success"><FaCheckCircle className="me-2" /><strong>Ligação iniciada! Acesse app.goto.com para prosseguir com a ligação.</strong></Alert>
                                                        }
                                                    </div>
                                                :
                                                <h4 className="text-center mt-3"><FaClock />Aguardando login na Goto Connect...</h4>
                                    :
                                    <h4 className="text-center mt-3"><FaExclamation /> O seu cliente não possui uma integração com o Goto Connect.</h4>
                                    }
                                </Col>
                            )}
                            {campo.tipo === 'arquivo' && (
                                <Col sm={6} className="mb-3">
                                    <Form.Group>
                                        <Form.Label>{campo.nome}</Form.Label>
                                        <Form.Control 
                                            type="file" 
                                            required={campo.obrigatorio}
                                            onChange={(e) => this.handleChangeCampo(campo.id, e)}
                                        />
                                        {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                    </Form.Group>
                                </Col>
                            )}
                        </React.Fragment>
                        ))}
                    </Row>
                </div>
            ))        
        );
    }


    renderizaCamposHistorico = (campos) => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {}
        for(let i = 0; i < campos.length; i++) {
            let item = campos[i];
            const secao = item.formulario_campo__sessao || '0_sem_sessao'

            if(!(secao in objCampos)){
                objCampos[secao] = [];    
            }

            objCampos[secao].push(item)
        }

        return (
            Object.keys(objCampos).map((nome_secao) => (
                <div className="row-list pb-0 mb-2" key={nome_secao}>
                    {nome_secao && <h6><strong>{tiposSessoesCampos[nome_secao] ? tiposSessoesCampos[nome_secao] : (nome_secao === '0_sem_sessao' ? '' : nome_secao)}</strong></h6>}            
                    <Row>
                        {objCampos[nome_secao].map((campo) => (
                        <React.Fragment key={campo.id}>
                            <div key={campo.id} className="col-12 col-sm-6">
                                {campo.arquivo ? (
                                    <>
                                        <Button variant="light" className="btn-sm mb-3" href={campo.arquivo} target="_blank">
                                            <FaEye /> Ver {campo.formulario_campo__nome}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <strong>{campo.formulario_campo__nome}:</strong>
                                        {campo.valor.match(/^\d{4}-\d{2}-\d{2}$/) ? (
                                            <p>{formataDataExibicao(campo.valor)}</p>
                                        ) : (
                                            <div style={{ whiteSpace: "pre-wrap" }}>
                                                <p>
                                                {campo.valor === "true"
                                                    ? "Sim"
                                                    : campo.valor === "false"
                                                    ? "Não"
                                                    : campo.valor}
                                                </p>
                                            </div>
                                        )}                                                                             
                                    </>
                                )}
                            </div>
                        </React.Fragment>
                        ))}
                    </Row>
                </div>
            ))        
        );
    }

    // Método para alternar a visibilidade dos detalhes de cada relato
    toggleDetalhesRelato = (relatoId) => {
        this.setState(prevState => ({
            exibirDetalhesRelato: {
                ...prevState.exibirDetalhesRelato,
                [relatoId]: !prevState.exibirDetalhesRelato[relatoId]
            }
        }));
    }

    limparEstadoModal = () => {
        this.setState({
          agendamento_data: '',
          agendamento_prestador_id: '',
          agendamento_valor: '',
          agendamento_servico_procedimento_id: '',
          agendamento_servico_video_conferencia: '',
          enviarKitAgendamento: null,
          dataEnvioKit: ''
        });
    };

    handleShowModalAcoes = (acao) => {
        this.limparEstadoModal();
        if(acao) {
            this.setState({ 
                programa_acao_id: acao.programa_acao_id,
                programa_acao_nome: acao.dados_programa_acao.nome,
                acao_id: acao.id,
                acao_descricao: acao.descricao,
                acao_observacoes: acao.observacoes,
                acao_realizado: acao.realizado,
                acao_data: acao.data_acao,
                acao_hora: acao.hora_acao,
                showModalAcoes: true
            }, () => {
                
            });
        } else {
            this.setState({ 
                programa_acao_id: '',
                programa_acao_nome: '',
                acao_id: '',
                acao_descricao: '',
                acao_observacoes: '',
                acao_realizado: '',
                acao_data: '',
                acao_hora: '',
                showModalAcoes: true
            });
        }

        const modal = document.querySelector(".modal-overlay-top");
        const backdrop = document.querySelector(".backdrop-overlay-top");

        if (modal) modal.style.zIndex = 1060;
        if (backdrop) backdrop.style.zIndex = 1059;
        
    };

    handleCloseModalAcoes = () => {
        this.limparEstadoModal();
        this.setState({ showModalAcoes: false });
    };

    carregaAcoes = async (inputValue) => {
        try {
            const response = await api.get(`/programas/acoes/?programa_id=${this.state.programa_id}&nome=${inputValue}`);
            const opcoesFiltradas = response.data.results.map(acao => ({
                value: acao.id,
                label: acao.nome
            }));
            return opcoesFiltradas;
        } catch (error) {
            console.error('Erro ao carregar ações:', error);
            return [];
        }
    };

    handleChangeAcao = (event, fieldName) => {
        if(fieldName == 'programa_acao_id') {
           this.setState(prevState => ({
                programa_acao_id: event.value, 
                programa_acao_nome: event.label,
            }));
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleShowFaqModal = () => {
        this.setState({ showFaqModal: true });
    };

    handleCloseFaqModal = () => {
        this.setState({ showFaqModal: false });
    };

    handleSelectFaq = (selectedIds, selectedObjects) => {
        
        this.setState(prevState => {
            const currentFaqs = prevState.faqs_selecionadas;
            const newFaqsList = selectedIds.map(id => {
                const foundInNew = selectedObjects.find(o => o.id === id);
                if (foundInNew) return foundInNew;
                
                const foundInOld = currentFaqs.find(o => o.id === id);
                if (foundInOld) return foundInOld;
                
                return { id: id, pergunta: 'Carregando...' };
            });

            return { faqs_selecionadas: newFaqsList };
        });
    };

    handleRemoveFaq = (faqId) => {
        this.setState(prevState => ({
            faqs_selecionadas: prevState.faqs_selecionadas.filter(f => f.id !== faqId)
        }));
    };

    enviaAcao = (e) => {
        e.preventDefault();
        const MySwal = withReactContent(Swal)
        if (!this.state.programa_acao_id) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma ação selecionada. Por favor, selecione uma ação para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.acao_descricao) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma descrição informada. Por favor, informe uma descrição para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.acao_data) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma data informada. Por favor, informe uma data para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        if (!this.state.acao_hora) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'Nenhuma hora informada. Por favor, informe uma hora para continuar.',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            return; // Interrompe a execução do método
        }

        this.setState({
            loading: true,
        });

        //vererifica se é edição ou adição
        const url = (this.state.acao_id) ? '/atendimentos/acoes/'+this.state.acao_id+'/' : '/atendimentos/acoes/'
        const metodo = (this.state.acao_id) ? 'put' : 'post'
        const realizado = (this.state.acao_realizado === "Sim") ? true : false;

        const data = {
            atendimento_id: this.state.atendimento_id,
            programa_acao_id: this.state.programa_acao_id,
            descricao: this.state.acao_descricao,
            data_acao: this.state.acao_data,
            hora_acao: this.state.acao_hora,
            realizado: realizado,
            pessoa_id: 1
        }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: data
        })
        .then(response => {
            
            const textSwal = (this.state.acao_id) ? 'Ação atualizada com sucesso' : 'Ação cadastrada com sucesso';

            this.setState({
                loading: false
            });

            // Tudo concluído aqui, agora pode navegar
            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            }).then((result) => {
                //redireciona
                this.carregarAcoes();
                this.handleCloseModalAcoes();
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar ação, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                };
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: 'Atenção',
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })

            //Sentry.captureException(erro_msg);
        });
    };

    handleChangeCampoAtendExtra = (id, value, marcado = null) => {
        // Verifica se o valor é um evento (para campos de arquivo, por exemplo)
        const isEvent = value && value.target;

        let finalValue = value;

        if (marcado !== null) {
            this.setState(prevState => {
                const valoresAnteriores = prevState.valoresCamposExtra[id]
                    ? prevState.valoresCamposExtra[id].split(',')
                    : [];
    
                let novosValores;
                if (marcado) {
                    // Adiciona o valor se ainda não estiver presente
                    novosValores = [...new Set([...valoresAnteriores, value])];
                } else {
                    // Remove o valor
                    novosValores = valoresAnteriores.filter((v) => v !== value);
                }
    
                return {
                    valoresCamposExtra: {
                        ...prevState.valoresCamposExtra,
                        [id]: novosValores.join(','),
                    },
                };
            });
            return;
        }

        // Se for um evento e um campo de arquivo, captura o arquivo; caso contrário, usa o valor diretamente
        if (isEvent && value.target.type === "file") {
            finalValue = value.target.files[0]; // Pode ser undefined se nenhum arquivo for selecionado
        }
        else if(isEvent && (value.target.type === "checkbox" || value.target.type === "radio")){
            finalValue = value.target.checked
        } 
        else if (isEvent) {
            finalValue = value.target.value;
        }

        // Atualiza o estado
        /*this.setState(prevState => ({
            valoresCamposExtra: {
                ...prevState.valoresCamposExtra,
                [id]: finalValue,
            },
        }));*/

        this.setState(prevState => {
            const novosCamposOutroExtra = { ...prevState.camposOutrosExtra };
    
            if (!isEvent || (isEvent && value.target.type != "file" && value.target.type != "checkbox" && value.target.type != "radio")) {
                if (finalValue.toLowerCase() === 'outro') {
                    // Se "Outro" foi selecionado, adicione ao estado
                    novosCamposOutroExtra[id] = '';
                } else {
                    // Caso contrário, remova do estado
                    delete novosCamposOutroExtra[id];
                }
            }

            return {
                valoresCamposExtra: {
                    ...prevState.valoresCamposExtra,
                    [id]: finalValue,
                },
                camposOutrosExtra: novosCamposOutroExtra,
            };
        });
    };

    handleChangeOutroExtra = (id, valor) => {
        this.setState(prevState => ({
            camposOutrosExtra: {
                ...prevState.camposOutrosExtra,
                [id]: valor,
            },
        }));
    };

    renderizaCamposExtra = (desabilitar_edicao, programa_id) => {
        //gera um dicionario agrupando os campos pela sessao
        let objCampos = {};
        let disclaimers = {}; // Para armazenar o disclaimer de cada seção
        let dados_usuario = getCurrentUser();

        if(this.state.atendimento_campos.length == 0) {
            return;
        }

        for (let i = 0; i < this.state.atendimento_campos.length; i++) {
            let item = this.state.atendimento_campos[i];
            const programa = item.programas_list.find((p) => p.programa_id === Number(programa_id));

            if (programa) {
                const secao = programa.secao || '0_sem_sessao';

                if (!(secao in objCampos)) {
                    objCampos[secao] = [];
                    disclaimers[secao] = programa.disclaimer || null; // Salva o disclaimer da seção
                }

                // Percorre os valores dos campos
                item.valor = '';
                for (let j = 0; j < this.state.camposExtraCadastrados.length; j++) {
                    let itemValor = this.state.camposExtraCadastrados[j];

                    if (itemValor.campo_slug === item.slug) {
                        item.valor = itemValor.valor;
                    }
                }

                objCampos[secao].push(item);
            }
        }

        const valorPorSlug = this.getValoresPorSlug();

        // Filtra as seções com pelo menos um campo visível
        const secoesVisiveis = Object.keys(objCampos).filter((nome_secao) =>
            objCampos[nome_secao].some((campo) => {
                // --- PRESTADORES: somente show-on-perfil e categoria compatível
                if (dados_usuario.tipo_usuario === 'prestador') {
                    if (campo.mascara?.startsWith("show-on-prestador=")) {
                        const allowed = campo.mascara.split("=")[1].split("|");
                        return allowed.includes(dados_usuario.prestador_categoria);
                    }
                    return false;
                }

                //Verifica exibição do campo por status
                if (campo.mascara && campo.mascara.startsWith("show-on-status=")) {
                    const requiredSlugs = campo.mascara.split("=")[1].split("|"); // Divide os slugs separados por '|'
                    return (
                        this.state.finalizado ||
                        this.state.cancelado ||
                        requiredSlugs.includes(this.state.programa_status_slug)
                    ); // Verifica se o slug atual está na lista
                }

                if (campo.mascara && campo.mascara.startsWith('show-on[')) {
                    return this.matchShowOnMask(campo, valorPorSlug);
                }
                
                return true; // Campos sem restrição sempre são visíveis
            })
        );

        return (
            secoesVisiveis.map((nome_secao) => (
                objCampos[nome_secao] && objCampos[nome_secao].length > 0 && (
                    <div className="row-list" key={nome_secao}>
                        {(nome_secao && nome_secao !== "0_sem_sessao") && (
                            <div>
                                <h6 className="sessao-campos-extra mt-3 mb-3">
                                    <strong>{tiposSessoesAtendExtra[nome_secao] ? tiposSessoesAtendExtra[nome_secao] : nome_secao}</strong>
                                </h6>
                                {/* Exibe o disclaimer da seção, se existir */}
                                {disclaimers[nome_secao] && (
                                    <div className="alert alert-info" role="alert">
                                        {disclaimers[nome_secao]}
                                    </div>
                                )}
                            </div>
                        )}
                        
                        <Row>
                            {objCampos[nome_secao].map((campo) => {

                                //Verifica prestador se tem permissão para visualizar campo
                                if (dados_usuario.tipo_usuario === 'prestador') {
                                    if (!campo.mascara?.startsWith("show-on-prestador=")) return null;
                                    
                                    const allowed = campo.mascara.split("=")[1].split("|");
                                    if (!allowed.includes(dados_usuario.prestador_categoria)) return null;
                                }

                                // Verifica se o campo deve ser exibido baseado no programa_status_slug
                                if (campo.mascara && campo.mascara.startsWith("show-on-status=")) {
                                    const requiredSlugs = campo.mascara.split("=")[1].split("|"); // Divide os slugs separados por '|'
                                    if (
                                        !this.state.finalizado &&
                                        !this.state.cancelado &&
                                        !requiredSlugs.includes(this.state.programa_status_slug)
                                    ) {
                                        // Não renderiza o campo se o slug não corresponder
                                        return null;
                                    }
                                }

                                // Dependência por outro campo (ex.: show-on[local_aplicacao=Domicílio])
                                if (campo.mascara && campo.mascara.startsWith('show-on[')) {
                                    if (!this.matchShowOnMask(campo, valorPorSlug)) return null;
                                }

                                const programa = campo.programas_list.find(
                                    (p) => p.programa_id === Number(programa_id)
                                );
                                
                                // Verifica se deve exibir o link "Ver histórico"
                                const mostrarHistorico = programa && programa.gerar_historico === true;
                                
                                let disabled = (desabilitar_edicao || campo.mascara === 'disabled') ? true : false;
                            
                                return (
                                    <React.Fragment key={campo.id}>
                                        {campo.tipo === 'texto' || campo.tipo === 'area_texto' || campo.tipo === 'data' || campo.tipo === 'selecao' || campo.tipo === 'radio' || campo.tipo === 'numero' || campo.tipo === 'checkbox' ? (
                                            <>
                                                <Col sm={campo.tipo === 'area_texto' ? 12 : 6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>{campo.nome} {campo.obrigatorio ? <span className="text-danger">*</span> : ''}</Form.Label>
                                                        {campo.descricao && <p className="mb-1"><Form.Text className="text-muted" style={{fontSize: '0.9em'}}>{campo.descricao}</Form.Text></p>}
                                                        {
                                                        (campo.tipo === 'selecao') ? (
                                                            <Form.Control
                                                                as="select"
                                                                defaultValue={campo.valor}
                                                                required={campo.obrigatorio}
                                                                onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                disabled={disabled}
                                                            >
                                                                <option value="">Selecione...</option>
                                                                {campo.opcoes.split('\n').map((opcao, idx) => {
                                                                    const [valor, label] = opcao.split(':').map(item => item.trim()); // Remove espaços adicionais
                                                                    return <option key={idx} value={valor}>{label}</option>;
                                                                })}
                                                            </Form.Control>

                                                            ) 
                                                        : 
                                                            (campo.tipo === 'texto' || campo.tipo === 'data' || campo.mascara === 'number') ? (
                                                                <Form.Control
                                                                    type={
                                                                        campo.mascara === 'number' ? 'number' : 
                                                                        campo.tipo === 'data' ? 'date' : 'text'
                                                                    }
                                                                    disabled={disabled}
                                                                    defaultValue={
                                                                        campo.tipo === 'data'
                                                                            ? (campo.valor ? campo.valor.substring(0, 10) : '')
                                                                            : campo.valor
                                                                    }
                                                                    required={campo.obrigatorio}
                                                                    onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                />
                                                            )
                                                            : 
                                                            (campo.tipo === 'numero' || campo.mascara === 'number') ? (
                                                                <Form.Control
                                                                    type="number"
                                                                    disabled={disabled}
                                                                    defaultValue={this.state.valoresCamposExtra?.[campo.id] || campo.valor || ''}
                                                                    required={campo.obrigatorio}
                                                                    onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                />
                                                            )
                                                            : (campo.tipo === 'checkbox') ? (
                                                                <div>
                                                                    {(campo.opcoes || '').split('\n').map((opcao, idx) => {
                                                                    const [valor, label] = opcao.split(':');
                                                                    const selecionados = (this.state.valoresCamposExtra?.[campo.id] || '').split(',');
                                                                    return (
                                                                        <Form.Check
                                                                        key={`checkbox_${campo.id}_${idx}`}
                                                                        type="checkbox"
                                                                        label={label || valor}
                                                                        value={valor}
                                                                        checked={selecionados.includes(valor)}
                                                                        disabled={disabled}
                                                                        onChange={(e) => {
                                                                            this.handleChangeCampoAtendExtra(campo.id, valor, e.target.checked);
                                                                        }}
                                                                        />
                                                                    );
                                                                    })}
                                                                </div>
                                                            )
                                                            :
                                                                (campo.tipo === 'radio') ? 
                                                                (
                                                                    <div>
                                                                        {campo.opcoes.split('\n').map((opcao, indexO) => {
                                                                            const [valorRadio, labelRadio] = opcao.split(':');
                                                                            // Verifica se já existe um valor alterado no estado; caso contrário, usa o valor original do campo
                                                                            const valorSelecionado = this.state.valoresCamposExtra.hasOwnProperty(campo.id)
                                                                                ? this.state.valoresCamposExtra[campo.id]
                                                                                : campo.valor;
                                                                            
                                                                            return (
                                                                                <Form.Check 
                                                                                    inline 
                                                                                    type="radio" 
                                                                                    label={labelRadio} 
                                                                                    key={`radio_${campo.id}_opcao_${indexO}`} 
                                                                                    id={`radio_${campo.id}_opcao_${indexO}`}
                                                                                    value={valorRadio} 
                                                                                    disabled={disabled}
                                                                                    onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                                    checked={ valorRadio === valorSelecionado }
                                                                                />                                                                                                                        
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )
                                                                :
                                                                (
                                                                    <Form.Control
                                                                        as="textarea"
                                                                        defaultValue={campo.valor}
                                                                        required={campo.obrigatorio}
                                                                        disabled={disabled}
                                                                        className="custom-textarea2"
                                                                        onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e.target.value)}
                                                                    />
                                                                )
                                                        }
                                                    </Form.Group>
                                                    {/* Link para ver histórico */}
                                                    {mostrarHistorico && (
                                                        <a
                                                            href="#"
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.handleShowHistorico(campo.id, campo.nome);
                                                            }}
                                                            className="text-decoration-underline text-primary small d-block mt-1"
                                                        >
                                                            Ver histórico
                                                        </a>
                                                    )}
                                                </Col>
                                                {(this.state.valoresCamposExtra[campo.id]?.toLowerCase() === 'outro' || ((campo.valor?.toLowerCase() === 'outro' || campo.valor?.startsWith("Outro - ")) && !this.state.valoresCamposExtra[campo.id])) && (
                                                <Col sm={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Descreva</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            value={
                                                                this.state.camposOutrosExtra[campo.id] 
                                                                    ? this.state.camposOutrosExtra[campo.id] 
                                                                    : campo.valor.startsWith("Outro - ")
                                                                        ? campo.valor.replace("Outro - ", "")
                                                                        : campo.valor || ''
                                                            }
                                                            onChange={(e) => this.handleChangeOutroExtra(campo.id, e.target.value)}
                                                            required={true}
                                                            disabled={disabled}
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                )}
                                            </>
                                        ) : null}
                                    
                                        {campo.tipo === 'arquivo' && (
                                            <Col sm={6} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label>{campo.nome}</Form.Label>
                                                    <Form.Control 
                                                        type="file" 
                                                        required={campo.obrigatorio}
                                                        disabled={disabled}
                                                        onChange={(e) => this.handleChangeCampoAtendExtra(campo.id, e)}
                                                    />
                                                    {campo.descricao && <Form.Text className="text-muted">{campo.descricao}</Form.Text>}
                                                </Form.Group>
                                            </Col>
                                        )}

                                        {campo.tipo === 'repeater' && Array.isArray(campo.repetidor_list) && (
                                            <Col sm={12} className="mb-3">
                                                <Form.Group>
                                                    <Form.Label><strong>{campo.nome}</strong></Form.Label>
                                                    
                                                    {(this.state.valoresCamposExtra[campo.id] || []).map((item, index) => (
                                                        <Row key={`${campo.id}_repetidor_${index}`} className="align-items-end mb-2 border rounded p-2">
                                                            {campo.repetidor_list.map((subcampo) => {
                                                                //const valor = item[subcampo.id] || '';
                                                                const cell  = item[subcampo.id] || {};
                                                                const valor = cell.valor || '';
                                                                
                                                                const subId = `${campo.id}_${subcampo.slug}_${index}`;
                                                                return (
                                                                    <Col sm={5} key={subId}>
                                                                        <Form.Label>{subcampo.nome}</Form.Label>
                                                                        {subcampo.tipo === 'selecao' ? (
                                                                            <Form.Control
                                                                                as="select"
                                                                                value={valor}
                                                                                required={subcampo.obrigatorio}
                                                                                onChange={(e) => this.handleChangeRepeater(campo.id, index, subcampo.slug, subcampo.id, e.target.value)}
                                                                            >
                                                                                <option value="">Selecione...</option>
                                                                                {subcampo.opcoes.split('\n').map((op, i) => {
                                                                                    const [v, l] = op.split(':').map(s => s.trim());
                                                                                    return <option key={i} value={v}>{l}</option>;
                                                                                })}
                                                                            </Form.Control>
                                                                        ) : subcampo.tipo === 'numero' ? (
                                                                            <Form.Control
                                                                                type="number"
                                                                                value={valor}
                                                                                required={subcampo.obrigatorio}
                                                                                onChange={(e) => this.handleChangeRepeater(campo.id, index, subcampo.slug, subcampo.id, e.target.value)}
                                                                            />
                                                                        ) : (
                                                                            <Form.Control
                                                                                type="text"
                                                                                value={valor}
                                                                                required={subcampo.obrigatorio}
                                                                                onChange={(e) => this.handleChangeRepeater(campo.id, index, subcampo.slug, subcampo.id, e.target.value)}
                                                                            />
                                                                        )}
                                                                    </Col>
                                                                );
                                                            })}
                                                            <Col sm="auto" className="d-flex align-items-end">
                                                                <Button variant="danger" className="btn-sm mb-1" onClick={() => this.removerRepetidor(campo.id, index, campo.nome)}>X</Button>
                                                            </Col>
                                                        </Row>
                                                    ))}
                                                    <Row>
                                                        <Col>
                                                            <Button variant="outline-success" className="btn-sm" onClick={() => this.adicionarRepetidor(campo.id, campo.repetidor_list)}>
                                                                Adicionar {campo.nome}
                                                            </Button>
                                                            {/* Link para ver histórico */}
                                                            {mostrarHistorico && (
                                                                <a
                                                                    href="#"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        this.handleShowHistorico(campo.id, campo.nome);
                                                                    }}
                                                                    className="text-decoration-underline text-primary small d-block mt-1"
                                                                >
                                                                    Ver histórico
                                                                </a>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                        )}

                                    </React.Fragment>
                                );
                            })}
                        </Row>
                    </div>
                )
            ))        
        );
    }

    /**
     * Monta um mapa { slug: valorAtual } considerando:
     * - valor salvo (this.state.camposExtraCadastrados)
     * - overrides em edição (this.state.valoresCamposExtra[campo.id])
     */
    getValoresPorSlug = () => {
        const valorPorSlug = {};

        for (const item of this.state.atendimento_campos || []) {
            // valor "base" vindo dos registros já salvos
            let valorBase = '';
            for (const v of (this.state.camposExtraCadastrados || [])) {
            if (v.campo_slug === item.slug) {
                valorBase = v.valor;
                break;
            }
            }

            // override do usuário em edição (se houver)
            const override = this.state.valoresCamposExtra?.[item.id];
            const valorAtual = (override !== undefined && override !== null) ? override : (item.valor ?? valorBase ?? '');

            valorPorSlug[item.slug] = valorAtual;
        }

        return valorPorSlug;
    };

    // Normaliza strings para comparação robusta (case/acentos/espaços)
    normalize = (s) => (s ?? '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase();

    /**
     * Interpreta máscaras condicionais do tipo:
     *   show-on[slug=ValorA|ValorB]
     * Suporta múltiplos valores (separados por "|").
     * Funciona também para campos múltiplos (checkbox com valores "a,b,c").
     */
    matchShowOnMask = (campo, valorPorSlug) => {
        const mask = campo?.mascara || '';
        if (!mask.startsWith('show-on[') || !mask.endsWith(']')) return true;

        const inner = mask.slice(8, -1); // conteúdo entre colchetes
        const eqIdx = inner.indexOf('=');
        if (eqIdx === -1) return true;

        const depSlug = inner.slice(0, eqIdx).trim();
        const rawVals = inner.slice(eqIdx + 1).trim();

        if (!depSlug || !rawVals) return true;

        const allowed = rawVals.split('|').map(this.normalize);
        const atual = (valorPorSlug[depSlug] ?? '').toString();

        // Se o campo dependente for multi (checkbox), virá "a,b,c"
        const atuais = atual.split(',').map(this.normalize);

        // Verdadeiro se QUALQUER um dos valores atuais bater com allowed
        return atuais.some(v => allowed.includes(v));
    };

    validarCamposExtra = () => {
        let camposInvalidos = [];
        const dados_usuario = getCurrentUser();
        const valorPorSlug = this.getValoresPorSlug();

        const MySwal = withReactContent(Swal);
        
        // Percorre os campos agrupados
        this.state.atendimento_campos.forEach((campo) => {
            let isVisivel = true;

            // --- PRESTADOR: mesma regra do renderizaCamposExtra ---
            if (dados_usuario.tipo_usuario === 'prestador') {
                if (!campo.mascara?.startsWith("show-on-prestador=")) {
                    isVisivel = false;
                } else {
                    const allowed = campo.mascara.split("=")[1].split("|");
                    if (!allowed.includes(dados_usuario.prestador_categoria)) {
                        isVisivel = false;
                    }
                }
            }
            
            // --- show-on-status=slug1|slug2 ---
            if (isVisivel && campo.mascara && campo.mascara.startsWith("show-on-status=")) {
                const requiredSlugs = campo.mascara.split("=")[1].split("|");
                if (
                    !this.state.finalizado &&
                    !this.state.cancelado &&
                    !requiredSlugs.includes(this.state.programa_status_slug)
                ) {
                    isVisivel = false;
                }
            }

            // --- show-on[slug=valor] ---
            if (isVisivel && campo.mascara && campo.mascara.startsWith('show-on[')) {
                if (!this.matchShowOnMask(campo, valorPorSlug)) {
                    isVisivel = false;
                }
            }

            const isHabilitado = campo.mascara !== "disabled";

            // valor atual (considera estado ou valor default)
            const valorAtual = this.state.valoresCamposExtra[campo.id] ?? campo.valor ?? "";
            
            if (
                isVisivel &&
                !this.state.reativar_atendimento &&
                isHabilitado &&
                campo.obrigatorio &&
                (
                    valorAtual === null ||
                    valorAtual === undefined ||
                    String(valorAtual).trim() === ""
                )
            ) {
                camposInvalidos.push(campo.nome);
            }
        });
    
        if (camposInvalidos.length > 0) {
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: "Atenção!",
                html: `Os seguintes campos obrigatórios não foram preenchidos:<br><br>- ${camposInvalidos.join("<br>- ")}`
            });
            return false;
        }
    
        return true;
    };

    carregaCamposExtraPrograma = async () => {
        let dados_usuario = getCurrentUser();
        const programa_id = (this.state.programa_id) ? this.state.programa_id : dados_usuario['ambiente_programa_id'];
        if (programa_id) {
            try {
                const response = await api.get(`/atendimentos/campos/?programa_id=${programa_id}&order_by=asc&order=ordem&limit=500`);
                this.setState({ atendimento_campos: response.data.results });
    
            } catch (error) {
                console.error('Erro ao carregar campos:', error);
                Sentry.captureException('Erro ao carregar campos:', error);
            }
        }
    };

    carregarAcoes = () => {
        if (this.state.atendimento_id) {
            const url = `/atendimentos/acoes/?atendimento_id=${this.state.atendimento_id}`
            api.get(url)
                .then(response => {
                    this.setState({ acoes: response.data });
                })
                .catch(error => {
                    console.error('Erro ao carregar ações:', error);
                    //Sentry.captureException('Erro ao carregar agendamentos:', error);
                    
                    let erro_msg = 'Erro ao carregar açõess, tente novamente';

                    if(error.response && error.response.status === 500){
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
                });
        }
    };

    getOpcoesOrdenadas = () => {
        const opcoes = this.state.opcoes_atendimentos_para;

        if (!opcoes || Object.keys(opcoes).length === 0) return [];

        return Object.entries(opcoes)
            .sort(([siglaA, nomeA], [siglaB, nomeB]) => {
                // "Outros" sempre por último
                if (siglaA === 'outros') return 1;
                if (siglaB === 'outros') return -1;
                
                // Ordenação alfabética pelo nome (valor)
                return nomeA.localeCompare(nomeB, 'pt-BR');
            });
    };

    handleSelectTabs = (key) => {
        this.setState({ tab_key: key })
    }

    handleMarcarAcaoProximaComoRealizada = async () => {
        const acao = this.state.proxima_acao;
        if (!acao?.id) {
            Swal.fire('Atenção', 'Nenhuma ação encontrada.', 'warning');
            return;
        }

        const confirm = await Swal.fire({
            title: 'Confirmar?',
            text: 'Deseja marcar esta ação como realizada?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, marcar',
            cancelButtonText: 'Cancelar'
        });

        if (!confirm.isConfirmed) return;

        this.setState({ loading: true });

        try {
            const getResp = await api.get(`/atendimentos/acoes/${acao.id}/`);
            const atual = getResp.data;

            const payload = {
            atendimento_id: atual.atendimento_id ?? this.state.atendimento_id,
            programa_acao_id: atual.programa_acao_id ?? atual.programa_acao?.id ?? this.state.programa_acao_id,
            descricao: atual.descricao ?? this.state.acao_descricao ?? '',
            data_acao: atual.data_acao ?? this.state.acao_data,
            hora_acao: atual.hora_acao ?? this.state.acao_hora,
            realizado: true,
            pessoa_id: atual.pessoa_id ?? 1
            };

            await api.put(`/atendimentos/acoes/${acao.id}/`, payload);

            await Swal.fire('Sucesso', 'Ação marcada como realizada.', 'success');

            this.setState({ proxima_acao: null });
            if (typeof this.carregarAcoes === 'function') this.carregarAcoes();

            window.location.reload();

        } catch (error) {
            console.error('Erro ao marcar ação:', error);
            if (error.response) {
            console.error('Status:', error.response.status);
            console.error('Data:', error.response.data); 
            const serverMsg = typeof error.response.data === 'string'
                ? error.response.data
                : JSON.stringify(error.response.data);
            Swal.fire('Erro', `Não foi possível atualizar a ação. Detalhes: ${serverMsg}`, 'error');
            } else {
            Swal.fire('Erro', 'Não foi possível atualizar a ação.', 'error');
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    abrirModalFaq = (faq = null) => {
        this.setState({
            showFaqModal: true,
            modalBusca: '',
            modalSelectedFaqId: faq?.id || null,
        });
    };

    fecharModalFaq = () => {
        this.setState({
            showFaqModal: false,
            modalBusca: '',
            modalSelectedFaqId: null,
        });
    };

    handleModalBuscaChange = (e) => {
        this.setState({ modalBusca: e.target.value });
    };

    handleSelectModalFaq = (faqId) => {
        this.setState({ modalSelectedFaqId: faqId });
    };

    handleChangeCampoAsync = (id, valor) => {
        const novoValor = valor && valor.value ? valor.value : valor; // Verifica se é um objeto e pega o `value`, ou usa o valor diretamente
    
        this.setState(prevState => ({
            valoresFormulario: {
                ...prevState.valoresFormulario,
                [id]: novoValor,
            },
        }));
    };

    handleChangeCampoCheckSim = (id, value) => {
        let finalValue = value.target.checked ? 'sim' : 'nao';
        
        this.setState(prevState => {
            return {
                valoresFormulario: {
                    ...prevState.valoresFormulario,
                    [id]: finalValue,
                },
            };
        });
    };

    obterValorCampo = (idCampo) => {
        return this.state.valoresFormulario[idCampo];
    };

    fetchProdutosPrograma = async () => {
        try {
            const dados_usuario = getCurrentUser();
            const programa_id = dados_usuario['ambiente_programa_id'] || this.state.programa_id;

            const resp = await api.get(`/programas/produtos/?programa=${programa_id}&status=1`);

            const nomesUnicos = Array.from(new Set(
            (resp.data?.results || []).map(p => (p.dados_produto?.nome || '').split(' - ')[0]).filter(Boolean)
            ));

            const opcoes = nomesUnicos.map(nome => ({ value: nome, label: nome }));

            this.setState({ produtosOpcoes: opcoes });
        } catch (e) {
            console.error('Erro ao carregar produtos:', e);
            this.setState({ produtosOpcoes: [] });
        }
    };

    gerarPdfFarmaco = async (templateUrl, valoresCampos, camposOutro) => {
        // 1) baixa o template
        const resp = await fetch(templateUrl, { cache: 'no-store' });
        if (!resp.ok) throw new Error(`Falha ao baixar o PDF (HTTP ${resp.status})`);

        const ct = resp.headers.get('content-type') || '';
        if (!ct.includes('pdf')) {
            const preview = (await resp.clone().text()).slice(0, 200);
            console.warn('Conteúdo NÃO é PDF:', ct, preview);
            throw new Error('O arquivo retornado não é PDF');
        }

        const arrayBuf = await resp.arrayBuffer();
        const pdfDoc = await PDFDocument.load(arrayBuf);
        const form = pdfDoc.getForm();
        const MESES_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // O próprio template declara o formato no nome do campo (ex.: "Start Date DDMMMYYYYRow1"),
        // então dá para respeitá-lo sem depender da máscara do campo personalizado.
        const pdfFieldEsperaMesEmIngles = (pdfFieldName = '') =>
            /dd\s*\/?\s*mmm/i.test(String(pdfFieldName).replace(/[^a-z]/gi, ' '));

        const formatarDataPdfCondicional = (valorStr, campoConfig, pdfFieldName = '') => {
            const mascara = campoConfig?.mascara || "";
            const tipo = campoConfig?.tipo || "";

            if (tipo !== 'data' && tipo !== 'date') {
                return valorStr;
            }

            let dataObj;
            try {
                dataObj = new Date(valorStr + 'T12:00:00Z');
                if (isNaN(dataObj.getTime())) throw new Error('Data inválida');
            } catch (e) {
                return valorStr;
            }

            const dia = dataObj.getUTCDate().toString().padStart(2, '0');
            const ano = dataObj.getUTCFullYear();

            // Mês em inglês (DD/MMM/YYYY) quando a máscara pede ou quando o campo do PDF exige
            if (mascara.includes('format-mmm-en') || pdfFieldEsperaMesEmIngles(pdfFieldName)) {
                return `${dia}/${MESES_EN[dataObj.getUTCMonth()]}/${ano}`;
            }

            const mes = (dataObj.getUTCMonth() + 1).toString().padStart(2, '0');
            return `${dia}/${mes}/${ano}`;
        };

        const helv = await pdfDoc.embedFont(StandardFonts.Helvetica);
        form.updateFieldAppearances(helv);

        // 2) montar o pdfFieldMap a partir do que você tem em estado
        //    ajuste o nome desta fonte conforme seu state: campos_formulario, camposFormulario, etc.
        const campos = this.state.campos_formulario || this.state.camposFormulario || [];
        const pdfFieldMap = [];

        for (const campo of campos) {
            let raw = campo?.campos_pdf;
            if (!raw) continue;

            // normaliza para array de itens de mapeamento
            let entries = [];
            if (Array.isArray(raw)) {
                entries = raw;
            } else if (typeof raw === 'string') {
                try {
                    const parsed = JSON.parse(raw);
                    entries = Array.isArray(parsed) ? parsed : [parsed];
                } catch (e) {
                    console.warn('campos_pdf string inválido p/ campo', campo?.id, e);
                    continue;
                }
            } else if (typeof raw === 'object') {
                entries = [raw]; // <<=== 🍰 seu caso atual
            }

            // normaliza cada item no formato que seu preenchimento usa
            for (const item of entries) {
                const tRaw = (item.type || item.pdf_field_type || '').toString().toLowerCase();
                let tipo = 'text';
                if (tRaw === 'checkbox_group') tipo = 'checkbox_group';
                else if (tRaw === 'radio_group') tipo = 'radio_group';
                else if (tRaw.includes('radio')) tipo = 'radio';
                else if (tRaw === 'date_parts') tipo = 'date_parts';
                else if (tRaw === 'number_4digits') tipo = 'number_4digits';
                else if (tRaw.includes('checkbox')) tipo = 'checkbox';

                const meta = {
                    campoId: campo.id,
                    pdf_field_type: tipo,
                    pdf_field_name: item.name || item.pdf_field_name || null,
                    pdf_group_name: item.group || item.pdf_group_name || null,
                    pdf_unit_group: item.unit_group || item.pdf_unit_group || null,
                    transform: item.transform || null,
                };

                if (tipo === 'date_parts') {
                    meta.targets = item.targets || null;     // { dd, mm, yyyy }
                    meta.fontSize = item.fontSize ?? null;
                    meta.fontStrategy = item.fontStrategy ?? null;
                    meta.useMonthAbbr = item.useMonthAbbr ?? false;
                }

                if (tipo === 'number_4digits') {
                    meta.targets = item.targets || null;      // { d1, d2, d3, d4 }
                    meta.acceptComma = item.acceptComma ?? true;
                    meta.pad = item.pad ?? '';
                    meta.decimalDefault = item.decimalDefault ?? '0'; 
                }

                if (tipo === 'checkbox_group') {
                    meta.options_map = item.options_map || {};        // { value -> pdfFieldName }
                    meta.value_separator = item.value_separator ?? ', ';
                    meta.exclusive = item.exclusive ?? null;          // valor exclusivo (ex.: "none")
                    meta.map_by = (item.map_by || 'value').toLowerCase(); // "value" | "label"
                }

                if (tipo === 'radio_group') {
                    meta.options_map = item.options_map || {};
                    meta.map_by = (item.map_by || 'value').toLowerCase(); // "value" | "label"
                }

                pdfFieldMap.push(meta);
            }
        }

        // 3) helpers usados no preenchimento (exemplos)
        const setTextOriginalSize = (form, name, value) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                f.setText(value != null ? String(value) : '');
                // não chama setFontSize, nem updateAppearances
            } catch {}
        };
        const setTextIfExists = (form, name, value, font, fontSize = 9) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                f.setText(value != null ? String(value) : '');
                f.setFontSize(fontSize);
                // ponto-chave: regen por CAMPO com a fonte embutida
                f.updateAppearances(font);
            } catch (err) {
                console.warn('Campo de texto não encontrado:', name, err);
            }
        };

        // Maior tamanho <= maxSize em que o texto cabe na largura da caixa (1 linha).
        const fitSingleLineFontSize = (field, text, font, maxSize, minSize = FARMACO_TEXT_MIN_FONT_SIZE) => {
            try {
                const rect = field?.acroField?.getWidgets?.()[0]?.getRectangle?.();
                if (!rect?.width) return maxSize;

                const usableWidth = Math.max(10, rect.width - 4);
                for (let size = maxSize; size >= minSize; size -= 0.25) {
                    if (font.widthOfTextAtSize(text, size) <= usableWidth) return size;
                }
                return minSize;
            } catch {
                return maxSize;
            }
        };

        // Reduz a fonte só quando o texto estoura a largura da caixa; se couber,
        // mantém o tamanho já aplicado pelo helper anterior.
        const shrinkSingleLineIfOverflow = (form, name, value, font, maxSize) => {
            if (!name) return;
            try {
                const f = form.getTextField(name);
                if (f.isMultiline()) return;

                const text = value != null ? String(value) : '';
                if (!text) return;

                const fitted = fitSingleLineFontSize(f, text, font, maxSize);
                if (fitted >= maxSize) return;

                f.setFontSize(fitted);
                f.updateAppearances(font);
            } catch {
                // campo ausente/não-texto no template: mantém como o helper anterior escreveu
            }
        };
        const setCheckbox = (form, name, on) => {
            if (!name) return;
            try {
            const f = form.getCheckBox(name);
            on ? f.check() : f.uncheck();
            } catch {}
        };
        const selectRadio = (form, groupName, val) => {
            if (!groupName) return;
            try {
            const g = form.getRadioGroup(groupName);
            g.select(val != null ? String(val) : '');
            } catch {}
        };
        const toDDMMMYYYY = (val) => {
            if (!val) return '';
            const d = new Date(val);
            if (isNaN(d)) return '';
            const dd = String(d.getDate()).padStart(2, '0');
            const mmm = d.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // JAN, FEB...
            const yyyy = d.getFullYear();
            return `${dd}-${mmm}-${yyyy}`;
        };
        const splitDateToParts = (val) => {
            if (!val) return { dd: '', mmm: '', yyyy: '' };
            const d = new Date(val);
            if (isNaN(d)) return { dd: '', mmm: '', yyyy: '' };
            return {
            dd: String(d.getDate()).padStart(2, '0'),
            mmm: d.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
            yyyy: String(d.getFullYear())
            };
        };
        const applyTransforms = (v, transform) => {
            // opcional: se você definiu transforms no JSON (ex.: uppercase, trim, etc.)
            if (!transform) return v;
            let out = v;
            const tlist = Array.isArray(transform) ? transform : String(transform).split('|');
            for (const t of tlist) {
            const tt = String(t).trim().toLowerCase();
            if (tt === 'trim') out = (out ?? '').toString().trim();
            else if (tt === 'upper') out = (out ?? '').toString().toUpperCase();
            else if (tt === 'lower') out = (out ?? '').toString().toLowerCase();
            }
            return out;
        };
        const MONTH_ABBR = [
            "Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"
        ];
        const splitDateToPartsCustom = (val, useMonthAbbr = false) => {
            if (!val) return { dd: '', mm: '', yyyy: '' };

            // Preferir parsing “puro” de YYYY-MM-DD
            const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(val).trim());
            if (m) {
                const [, yyyy, mmStr, dd] = m;
                const mm = parseInt(mmStr, 10);

                return {
                    dd,
                    mm: useMonthAbbr ? MONTH_ABBR[mm - 1] : mmStr,
                    yyyy
                };
            }

            // fallback
            const d = new Date(val);
            if (isNaN(d)) return { dd: '', mm: '', yyyy: '' };

            const monthIndex = d.getMonth();

            return {
                dd: String(d.getDate()).padStart(2, '0'),
                mm: useMonthAbbr 
                    ? MONTH_ABBR[monthIndex] 
                    : String(monthIndex + 1).padStart(2, '0'),
                yyyy: String(d.getFullYear())
            };
        };
        const splitNumberTo4Digits = (
            val,
            { acceptComma = true, pad = '', decimalDefault = '0' } = {}
        ) => {
            if (val == null || val === '') return { d1: pad, d2: pad, d3: pad, d4: decimalDefault };

            let s = String(val).trim();
            if (acceptComma) s = s.replace(',', '.');
            s = s.replace(/[^\d.]/g, '');

            const [intRaw = '', decRaw = ''] = s.split('.');
            // remove zeros à esquerda, mantendo um único zero se necessário
            const intDigits = intRaw.replace(/^0+(?=\d)/, '') || (intRaw ? '0' : '');

            const u1 = intDigits.slice(-1) || '';     // unidades
            const u2 = intDigits.slice(-2, -1) || ''; // dezenas
            const u3 = intDigits.slice(-3, -2) || ''; // centenas
            const dec1 = decRaw.length ? decRaw.slice(0, 1) : decimalDefault; // 👈 aqui

            const fill = x => (x === '' ? pad : x);
            return { d1: fill(u3), d2: fill(u2), d3: fill(u1), d4: dec1 };
        };

        for (const meta of pdfFieldMap) {
            const { campoId, pdf_field_name, pdf_field_type, pdf_group_name, pdf_unit_group, transform } = meta || {};
            if (!campoId || !pdf_field_type) continue;

            let valor = valoresCampos[campoId];

            // “Outro”
            if (typeof valor === 'string' && valor.toLowerCase() === 'outro' && camposOutro && camposOutro[campoId]) {
                valor = `Outro - ${String(camposOutro[campoId]).trim()}`;
            }

            valor = applyTransforms(valor, transform);

            const campoConfig = campos.find(c => c.id === campoId);

            try {
                switch (pdf_field_type) {
                    case 'text': {
                        if (pdf_field_name) {
                            const valorFinal = formatarDataPdfCondicional(valor, campoConfig, pdf_field_name);
                            const fs = meta.fontSize ?? 10; // permite controlar via campos_pdf
                            setTextIfExists(form, pdf_field_name, valorFinal, helv, fs); // <--- Usar valorFinal
                            shrinkSingleLineIfOverflow(form, pdf_field_name, valorFinal, helv, fs);
                        }
                        break;
                    }
                    case 'checkbox': {
                        // torna booleano de forma robusta
                        const toBool = (x) => {
                        if (Array.isArray(x)) return x.some(toBool);
                        if (typeof x === 'string') return ['1','true','sim','on','yes','y','s'].includes(x.trim().toLowerCase());
                        return !!x;
                        };
                        if (pdf_field_name) setCheckbox(form, pdf_field_name, toBool(valor));
                        break;
                    }
                    case 'radio':
                        if (pdf_group_name) selectRadio(form, pdf_group_name, valor);
                        break;
                    case 'unit_flag': {
                        const units = Array.isArray(pdf_unit_group) && pdf_unit_group.length ? pdf_unit_group : [pdf_field_name];
                        for (const u of units) {
                        setCheckbox(form, u, String(u).toLowerCase() === String(valor).toLowerCase());
                        }
                        break;
                    }
                    case 'date_parts': {
                        const parts = splitDateToPartsCustom(valor, meta.useMonthAbbr);
                        const fs = meta.fontSize ?? null;
                        const useTemplate = (meta.fontStrategy || '').toLowerCase() === 'template';

                        const write = (name, val) => {
                            if (!name) return;
                            if (useTemplate || !fs) {
                            setTextOriginalSize(form, name, val);
                            } else {
                            setTextIfExists(form, name, val, helv, fs);
                            }
                        };

                        write(meta.targets?.dd,  parts.dd);
                        write(meta.targets?.mm,  parts.mm);
                        write(meta.targets?.yyyy, parts.yyyy);
                        break;
                    }
                    case 'number_4digits': {
                        const parts = splitNumberTo4Digits(valor, {
                            acceptComma: meta.acceptComma,
                            pad: meta.pad,
                            decimalDefault: meta.decimalDefault,
                        });

                        const write = (name, val) => {
                            if (!name) return;
                            setTextOriginalSize(form, name, val); // mantendo aparência original
                        };

                        write(meta.targets?.d1, parts.d1);
                        write(meta.targets?.d2, parts.d2);
                        write(meta.targets?.d3, parts.d3);
                        write(meta.targets?.d4, parts.d4);
                        break;
                    }
                    case 'checkbox_group': {
                        // 1) pegue as seleções do usuário
                        const raw = valor ?? '';
                        let selected = [];
                        if (Array.isArray(raw)) {
                            selected = raw;
                        } else if (typeof raw === 'string') {
                            selected = raw.split(meta.value_separator).map(s => s.trim()).filter(Boolean);
                        } else if (raw) {
                            selected = [String(raw)];
                        }

                        // 2) se mapear por label, converta label -> value usando as opções do campo (se precisar)
                        //    (Opcional: se você guarda apenas "valor", pode ignorar isso)
                        if (meta.map_by === 'label') {
                            // tenta montar um dicionário label->valor a partir de campo.opcoes ("v:Label")
                            const optLines = (campos.find(c => c.id === campoId)?.opcoes || '').split('\n');
                            const labelToValue = {};
                            for (const line of optLines) {
                            const [v, l] = line.split(':');
                            if (l) labelToValue[l.trim()] = (v || '').trim();
                            }
                            selected = selected.map(s => labelToValue[s] || s);
                        }

                        // 3) normaliza p/ comparação case-insensitive
                        const selSet = new Set(selected.map(s => String(s).toLowerCase()));

                        // 4) se houver opção exclusiva marcada (ex.: "none"), liga só ela
                        const exclusiveKey = meta.exclusive ? String(meta.exclusive).toLowerCase() : null;
                        const exclusiveOn = exclusiveKey && selSet.has(exclusiveKey);

                        // 5) percorre o options_map: marca/desmarca cada checkbox no PDF
                        for (const [valueKey, pdfName] of Object.entries(meta.options_map || {})) {
                            const k = String(valueKey).toLowerCase();
                            const on = exclusiveOn ? (k === exclusiveKey) : selSet.has(k);
                            setCheckbox(form, pdfName, on);
                        }

                        break;
                    }
                    case 'radio_group': {
                        const selected = valor ? String(valor).trim() : null;
                        if (!selected) break;

                        for (const [valueKey, pdfName] of Object.entries(meta.options_map || {})) {
                            const match = (String(valueKey).toLowerCase() === selected.toLowerCase());
                            setCheckbox(form, pdfName, match); // marca só o que bate, desmarca os outros
                        }
                        break;
                    }
                }
            } catch (e) {
                console.warn('Falha ao aplicar campo PDF', meta, e);
            }
        }

        try { form.flatten(); } catch {}

        const filledBytes = await pdfDoc.save();
        return new Blob([filledBytes], { type: 'application/pdf' });
    };
    
    render(){
        let dados_usuario = getCurrentUser();

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs activeKey={this.state.tab_key} id="tabs-atendimento" className="aditus-tabs"  onSelect={this.handleSelectTabs}>
                    <Tab eventKey="dadosAtendimento" title="Registro de Atendimento">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form>
                                    <h4>Dados do Atendimento</h4>
                                    {
                                        this.state.atendimento_id &&
                                        <Row>
                                            <Col sm={4} xs={12} className="mb-3">
                                                <label className="mr-3">Navegadora responsável: </label>
                                                <span> {this.state.dados_atendente?.nome}</span>
                                            </Col>
                                            <Col sm={4} xs={12} className="mb-3">
                                                <label className="mr-3">Data do atendimento: </label>
                                                <span> {formataDataHoraExibicao(this.state.data)}</span>
                                            </Col>
                                        </Row>
                                    }     
                                    {(dados_usuario['tipo_usuario'] === '' || dados_usuario['tipo_usuario'] === 'operador') && this.state.proxima_acao && this.state.proxima_acao.data_acao && !this.state.finalizado && !this.state.cancelado && (
                                        <Row>
                                            <Col sm={12}>
                                                <Alert variant="warning">
                                                    <h6><FaExclamationTriangle className="mb-1" /> Próxima Ação</h6>
                                                    <p>{this.state.proxima_acao.descricao}</p>
                                                    <p>Data prevista: <strong>{formataDataExibicao(this.state.proxima_acao.data_acao)}</strong> às <strong>{this.state.proxima_acao.hora_acao?.split('.')[0]}</strong></p>

                                                    <Button
                                                        variant="warning"
                                                        size="sm"
                                                        onClick={() => this.handleSelectTabs("acoesAtendimento")}
                                                    >
                                                        Ver Ações
                                                    </Button>
                                                    <Button
                                                        variant="success"
                                                        size="sm"
                                                        onClick={this.handleMarcarAcaoProximaComoRealizada}
                                                    >
                                                        Marcar como realizado
                                                    </Button>
                                                </Alert>
                                            </Col>
                                        </Row>
                                    )}                               
                                    <Row>
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do Usuário <span className="text-danger">*</span></Form.Label>
                                                <Form.Control as="select" name="receptivo_para_quem" value={this.state.receptivo_para_quem} required onChange={this.handleChange}>
                                                    <option value="">Selecione o tipo do usuário</option>
                                                    {this.getOpcoesOrdenadas().map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}                                             
                                                </Form.Control>
                                                <Form.Text id="formParaHelper" className="text-danger">{this.state.paraHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        {this.state.receptivo_para_quem === 'outros' && (
                                        <Col sm={4} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Especifique <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    type="text" 
                                                    name="receptivo_para_quem_outro" 
                                                    value={this.state.receptivo_para_quem_outro || ''} 
                                                    onChange={this.handleChange}
                                                    required
                                                    placeholder="Digite o tipo de usuário"
                                                />
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {dados_usuario['ambiente_cliente_id'] === "" && (
                                        <Col sm={4} xs={12}> 
                                            <Form.Group className="mb-3">
                                                <Form.Label>Cliente</Form.Label>
                                                <AsyncSelect
                                                    cacheOptions
                                                    loadOptions={this.carregarClientes}
                                                    defaultOptions
                                                    name="cliente_id"
                                                    placeholder="Buscar cliente..."
                                                    noOptionsMessage={() => "Nenhum cliente encontrado"}
                                                    onChange={e => this.handleChangeFiltros(e, 'cliente_id')}
                                                    value={this.state.filtro_cliente_id ? { value: this.state.filtro_cliente_id, label: this.state.filtro_cliente_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )}
                                        {this.state.filtro_cliente_id && dados_usuario['ambiente_programa_id'] === "" && (
                                        <Col sm={4} xs={12}> 
                                            <Form.Group className="mb-3">
                                                <Form.Label>Programa</Form.Label>
                                                <AsyncSelect          
                                                    key={this.state.programa_select_key}                                  
                                                    cacheOptions
                                                    loadOptions={this.carregaProgramas}
                                                    defaultOptions
                                                    name="programa_id"
                                                    placeholder={'Buscar programa...'}
                                                    noOptionsMessage={() => "Nenhum programa encontrado"}
                                                    onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                    value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                                />
                                            </Form.Group>
                                        </Col>
                                        )}
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>CPF</Form.Label>
                                                <Form.Control as={IMaskInput} mask="000.000.000-00" name="receptivo_cpf" value={this.state.receptivo_cpf} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Nome Completo <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" name="receptivo_nome" required value={this.state.receptivo_nome} onChange={this.handleChange} />    
                                                <Form.Text id="formNomeHelpBlock" className="text-danger">{this.state.nomeHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control type="email" required  name="receptivo_email" value={this.state.receptivo_email} onChange={this.handleChange} />                            
                                                <Form.Text id="formEmailHelpBlock" className="text-danger">{this.state.emailHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Telefone</Form.Label>
                                                <Form.Control as={IMaskInput} mask="(00) 00000-0000" name="receptivo_telefone" value={this.state.receptivo_telefone} onChange={this.handleChange} />
                                                <Form.Text id="formTelefoneHelpBlock" className="text-danger">{this.state.telefoneHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>

                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição do Atendimento <span className="text-danger">*</span></Form.Label>
                                                <Form.Control 
                                                    as="textarea" 
                                                    required 
                                                    name="receptivo_texto"
                                                    value={this.state.receptivo_texto} 
                                                    onChange={this.handleChange} 
                                                    className="custom-textarea"
                                                />
                                            </Form.Group>
                                        </Col>


                                        {/*<Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Relato de Farmacovigilância</Form.Label>
                                                <Form.Control 
                                                    as="select"
                                                    name="farmacovigilancia_relato"
                                                    value={this.state.farmacovigilancia_relato}
                                                    onChange={this.handleRelatoChange}
                                                    required
                                                >
                                                    <option value="">Selecione</option>
                                                    <option value="sim">Sim</option>
                                                    <option value="nao">Não</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        
                                        {this.state.farmacovigilancia_relato === "sim" && this.state.farmacovigilancia_formulario_id  && this.state.renderiza_campos && (
                                            <Col sm={12} xs={12}>
                                                {this.renderizaCamposFormulario()}
                                            </Col>
                                        )}*/}
                                    </Row>

                                    {this.state.atendimento_id && this.state.programa_dados.dados_status && (
                                        <Row>
                                            <Col sm={12} xs={12}>
                                                <div className="row-list mt-2">
                                                    <Row>
                                                        <Col sm={4} xs={12}>
                                                            <Form.Group className="mb-3">
                                                                <Form.Label>Status do Atendimento</Form.Label>
                                                                <Form.Control as="select" value={this.state.programa_status_id} name="programa_status_id" onChange={this.handleChange} disabled={this.state.finalizado}>
                                                                    <option value="">Selecione um status</option>
                                                                    {this.state.programa_dados.dados_status.map(status => (
                                                                        <option key={status.slug} value={status.id}>{status.nome}</option>
                                                                    ))}
                                                                </Form.Control>
                                                            </Form.Group>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}

                                    {this.state.atendimento_id && (
                                        <div className="mt-3">
                                            {this.renderizaCamposExtra(false, this.state.programa_id)}
                                        </div>
                                    )}

                                    {/* Renderização dos botões */}
                                    {this.state.atendimento_id &&  this.state.botoes_atendimento.length > 0 && (
                                        <>
                                            {this.renderModalBotao()}
                                            <Row className="mb-4">
                                                {this.state.botoes_atendimento.map((botao, index) => (
                                                    <React.Fragment key={index}>
                                                    {botao.tipo_usuario ? (
                                                        <>
                                                            {((dados_usuario['tipo_usuario'] == botao.tipo_usuario) || (dados_usuario['prestador_id'] > 0 && dados_usuario['prestador_categoria'] == botao.tipo_usuario && dados_usuario['prestador_categoria'] == this.state.etapa_atual.responsavel_etapa && !ocultar_etapa_atual.includes(dados_usuario['prestador_categoria']))) && !this.state.finalizado && (
                                                                <Col sm={12} md={4} lg={4} className="mb-3">
                                                                    <Button type="button" variant="secondary" size="sm" className="w-100" onClick={() => this.handleShowModalBotao(botao)}>
                                                                        <FaEdit /> {botao.titulo}
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </>
                                                    ): (
                                                        <>
                                                            {(dados_usuario['tipo_usuario'] == 'operador' || dados_usuario['tipo_usuario'] == 'gestor' || dados_usuario['tipo_usuario'] == '') && (
                                                                <Col sm={12} md={4} lg={4} className="mb-3">
                                                                    <Button type="button" variant="secondary" size="sm" className="w-100" onClick={() => this.handleShowModalBotao(botao)}>
                                                                        <FaEdit /> {botao.titulo}
                                                                    </Button>
                                                                </Col>
                                                            )}
                                                        </>
                                                    )}
                                                    </React.Fragment>
                                                ))}
                                            </Row>
                                        </>                                    
                                    )} 

                                    <Row>
                                        <Col sm={12} className="mb-3">
                                            <Card className="border p-3 bg-light">
                                                <div className="d-flex flex-column">
                                                    <h6 className="text-primary fw-bold mb-2"><FaQuestionCircle className="me-2" /> FAQs Vinculadas</h6>
                                                    
                                                    {this.state.faqs_selecionadas.length > 0 ? (
                                                        <Accordion className="mt-2 text-start">
                                                            {this.state.faqs_selecionadas.map((faq, index) => (
                                                                <Accordion.Item eventKey={index.toString()} key={faq.id}>
                                                                    <Accordion.Header>
                                                                        <div className="d-flex align-items-center w-100 justify-content-between me-3">
                                                                             <span className="fw-bold">{faq.pergunta}</span>
                                                                             <Button
                                                                                variant="link"
                                                                                className="p-0 text-danger ms-2"
                                                                                title="Remover"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    this.handleRemoveFaq(faq.id);
                                                                                }}
                                                                             >
                                                                                <FaTimes />
                                                                             </Button>
                                                                        </div>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                         <div dangerouslySetInnerHTML={{ __html: faq.resposta || '<span class="text-muted">Sem resposta disponível</span>' }} />
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            ))}
                                                        </Accordion>
                                                    ) : (
                                                        <small className="text-muted">Nenhuma FAQ vinculada.</small>
                                                    )}
                                                </div>
                                            </Card>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col sm={12} md={4} lg={4} className="mb-3">
                                            <Button variant="light" size="sm" className="me-1" onClick={() => this.abrirModalFaq()}>
                                                <FaTeamspeak className="me-2" /> Consultar FAQ
                                            </Button>
                                        </Col>
                                    </Row>

                                    {this.state.twilio_retorno 
                                    &&
                                    <Alert variant="success">
                                        <FaCheckCircle className="me-2" /><strong>Enviado WhatsApp nesse atendimento!</strong>
                                    </Alert>
                                    }

                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="button" className="btn-submit mt-3" disabled={this.state.loading} onClick={e => this.enviaRegistro(e, 'padrao')}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> {this.state.atendimento_id ? 'Atualizar Atendimento' : 'Registrar Atendimento'}
                                            </>
                                        )}
                                    </Button>

                                    {
                                    this.state.liberaBtnWhatsApp &&
                                    <Button variant="dark" type="button" className="mt-3 ms-2" disabled={this.state.loading} onClick={e => this.enviaRegistro(e, 'com_whatsapp')}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar e Enviar Whatsapp
                                            </>
                                        )}
                                    </Button>
                                    }
                                </Form> 
                            </Card.Body>                
                        </Card>

                                      
                    </Tab>
                    {this.state.atendimento_id && (
                    <Tab eventKey="historicoRelatos" title="Histórico de Relatos">
                        <Card className="cardDestaque">
                            <Card.Body>       
                                <h4><strong>Relatos:</strong></h4>   
                                {this.state.relatos_atendimento.length > 0 ? (
                                    this.state.relatos_atendimento.map((relato, relatoIndex) => (
                                        <div key={relatoIndex} className="row-list list-style-2 mb-2 pb-0">
                                            {relato.titulo != '' ? (
                                                <h6 className="relato-titulo">{relato.titulo}</h6>
                                            ) : (
                                                <h6 className="relato-titulo">Registro da Etapa</h6>
                                            )}
                                            <p>
                                                Data: <strong>{formataDataHoraExibicao(relato.data)}</strong> {'nome' in relato.dados_cadastrado_por ? 'por '+relato.dados_cadastrado_por.nome+' '+relato.dados_cadastrado_por.sobrenome : ''}
                                            </p>
                                            {this.state.exibirDetalhesRelato[relato.id] && (
                                                <div className="relato-valores">
                                                    {this.renderizaCamposHistorico(relato.valores_list)}
                                                </div>
                                            )}
                                            {/* Botão para abrir/fechar informações */}
                                            <div className="text-center show-hide-relato" onClick={() => this.toggleDetalhesRelato(relato.id)}>
                                                {this.state.exibirDetalhesRelato[relato.id] ? (
                                                    <>
                                                        Ocultar <FaChevronUp />
                                                    </>
                                                ) : (
                                                    <>
                                                        Ver Informações <FaChevronDown />
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>Nenhum relato cadastrado até o momento</p>
                                )}
                            </Card.Body>
                        </Card>
                    </Tab>
                    )}    

                    {this.state.atendimento_id && (
                    <Tab eventKey="acoesAtendimento" title="Ações">
                        <Card className="cardDestaque mt-4">
                            <Card.Body>                   
                                <Row className="align-items-center mb-3">
                                    <Col sm={6} lg={6}>
                                        <h6><strong>Ações do Atendimento</strong></h6>
                                    </Col>
                                    <Col sm={6} xs={6} className="text-end">                       
                                        <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalAcoes()}>
                                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Nova Ação'}                                       
                                        </Button>
                                    </Col>
                                </Row>
                                {('results' in this.state.acoes && this.state.acoes.results.length > 0) ? (
                            
                                    <Row>
                                        <Col sm={12} lg={12}>
                                            <Table responsive className="custom-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Descrição</th>
                                                        <th>Data / Hora </th>
                                                        <th>Realizado</th>  
                                                        <th>Opções</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.state.acoes.results.map((acoes, index) => ( 
                                                        <tr key={index}>
                                                            <td className="bg-id">#{acoes.id}</td>
                                                            <td className="td-border">{acoes.descricao}</td>
                                                            <td>
                                                                <div className="td-border">
                                                                    {formataDataExibicao(acoes.data_acao)} {acoes.hora_acao?.split('.')[0]}
                                                                </div>
                                                            </td>
                                                            <td className="td-border">{acoes.realizado ? 'Sim' : 'Não'}</td>
                                                            <td>
                                                                {!acoes.realizado && (
                                                                <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalAcoes(acoes)}>
                                                                    Atualizar Ação
                                                                </Button>  
                                                                )} 
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>   
                            ) : (
                                <p>Nenhuma ação cadastrada até o momento</p>
                            )}
                                        
                            </Card.Body>                
                        </Card>
                                
                    </Tab>
                    )}    
                </Tabs>

                <Modal show={this.state.showModalAcoes} onHide={this.handleCloseModalAcoes} size="lg" enforceFocus={false} className="modal-overlay-top" backdropClassName="backdrop-overlay-top" >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.acao_id ? 'Editar Lembrete de Ação' : 'Adicionar Lembrete de Ação'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={12} xs={12} className="mb-1">
                                <div className="row-list">
                                    <Form.Label className="mb-0">
                                        Ação
                                    </Form.Label>
                                    <hr className="mb-2 mt-1"></hr>
                                    <Form.Group className="mb-3">
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={this.carregaAcoes}
                                            defaultOptions
                                            name="programa_acao_id"
                                            placeholder="Buscar ação..."
                                            noOptionsMessage={() => "Nenhuma ação encontrada"}
                                            onChange={(e) => this.handleChangeAcao(e, 'programa_acao_id')}
                                            value={this.state.programa_acao_id ? { value: this.state.programa_acao_id, label: this.state.programa_acao_nome } : null}
                                        />    
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col sm={12} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Descrição</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="acao_descricao"
                                        value={this.state.acao_descricao}
                                        onChange={this.handleChangeAcao}
                                        placeholder="Descrição da ação"
                                    />
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data da Ação</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="acao_data"
                                        value={this.state.acao_data}
                                        onChange={this.handleChangeAcao}
                                        required
                                        min={new Date().toISOString().split("T")[0]}
                                    />
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Hora da Ação</Form.Label>
                                    <Form.Control
                                        type="time"
                                        name="acao_hora"
                                        value={this.state.acao_hora}
                                        onChange={this.handleChangeAcao}
                                        required
                                    />
                                </Form.Group>
                            </Col>

                            {this.state.acao_id && ( // Mostrar somente se for edição
                                <Col sm={12} xs={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Realizado</Form.Label>
                                        <div>
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label="Sim"
                                                value="Sim"
                                                checked={this.state.acao_realizado === "Sim"}
                                                onChange={this.handleChangeAcao}
                                                name="acao_realizado"
                                            />
                                            <Form.Check
                                                inline
                                                type="radio"
                                                label="Não"
                                                value="Não"
                                                checked={this.state.acao_realizado === "Não"}
                                                onChange={this.handleChangeAcao}
                                                name="acao_realizado"
                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            )}

                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.handleCloseModalAcoes}>
                            Fechar
                        </Button>
                        <Button variant="secondary" onClick={this.enviaAcao}>
                            {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : (this.state.acao_id ? 'Editar Ação' : 'Cadastrar Ação')}
                        </Button>
                    </Modal.Footer>
                </Modal>

                <SelecionarFaqModal 
                    show={this.state.showFaqModal}
                    onHide={this.handleCloseFaqModal}
                    onSelect={this.handleSelectFaq}
                    programaId={dados_usuario['ambiente_programa_id'] || this.state.filtro_programa_id || this.state.programa_id}
                    selectedFaqIds={this.state.faqs_selecionadas.map(f => f.id)}
                />
            </div>
        )
    }
}

export default withRouter(AtendimentoGeralEdit);
